/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * FinProject API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptInviteBody,
  AccountMapping,
  AccountStatement,
  ActivateAccountBody,
  ApplyDefaultAccountMappings200,
  ApplyDefaultAccountMappingsBody,
  ApplyDefaultAccountMappingsParams,
  Attachment,
  AuthUser,
  BalanceSheet,
  BoqItem,
  BudgetLine,
  CashFlowEntry,
  ChartOfAccount,
  CheckDemoEmailParams,
  CheckDemoResponse,
  ClientDocument,
  ClientInvoice,
  ClientReceipt,
  Company,
  CompanyBySlugResponse,
  ConvertClientDocumentToInvoice201,
  CreateAttachmentBody,
  CreateBoqItemBody,
  CreateBudgetLineBody,
  CreateCashFlowEntryBody,
  CreateChartOfAccountBody,
  CreateClientDocumentBody,
  CreateClientInvoiceBody,
  CreateClientReceiptBody,
  CreateCompanyBody,
  CreateCustomerBody,
  CreateExpenseCategoryBody,
  CreateJournalEntryBody,
  CreateMasterSCBody,
  CreateMasterStaffMemberBody,
  CreateMasterSupplierBody,
  CreatePayrollEntryBody,
  CreateProjectBody,
  CreatePromissoryNoteBody,
  CreateScInvoiceBody,
  CreateScPaymentBody,
  CreateSubcontractorBody,
  CreateSupplierBody,
  CreateSupplierInvoiceBody,
  CreateSupplierPaymentBody,
  CreateTaxRateBody,
  CreateTaxTypeBody,
  CreateUserBody,
  CreateVendorOrderBody,
  Customer,
  DeleteAttachmentParams,
  DemoLead,
  ErrorResponse,
  ExpenseCategory,
  GetAccountStatementParams,
  GetBalanceSheetParams,
  GetIncomeStatementParams,
  GetPartyStatementParams,
  GetTrialBalanceParams,
  GlEntry,
  HealthStatus,
  IncomeStatement,
  InvitationItem,
  InviteBody,
  JournalEntry,
  ListAccountMappingsParams,
  ListAttachmentsParams,
  ListBoqParams,
  ListBudgetParams,
  ListCashFlowParams,
  ListChartOfAccountsParams,
  ListClientDocumentsParams,
  ListClientInvoicesParams,
  ListClientReceiptsParams,
  ListCustomersParams,
  ListExpenseCategoriesParams,
  ListGlEntriesParams,
  ListJournalEntriesParams,
  ListMasterSCsParams,
  ListMasterStaffParams,
  ListMasterSuppliersParams,
  ListPayrollParams,
  ListProjectsParams,
  ListPromissoryNotesParams,
  ListScInvoicesParams,
  ListScPaymentsParams,
  ListSubcontractorsParams,
  ListSupplierInvoicesParams,
  ListSupplierPaymentsParams,
  ListSuppliersParams,
  ListTaxTypesParams,
  ListUsersParams,
  ListVendorOrdersParams,
  LoginBody,
  LoginResponse,
  MasterSC,
  MasterStaffMember,
  MasterSupplier,
  MemberItem,
  MessageResponse,
  PartyStatement,
  PayrollEntry,
  PostJournalEntryResponse,
  Project,
  PromissoryNote,
  ScInvoice,
  ScPayment,
  SelectCompanyBody,
  SelectCompanyResponse,
  SetupBody,
  SignupBody,
  Subcontractor,
  Supplier,
  SupplierInvoice,
  SupplierPayment,
  TaxRate,
  TaxType,
  TaxTypeWithRates,
  TrialBalanceRow,
  UpdateBoqItemBody,
  UpdateBudgetLineBody,
  UpdateCashFlowEntryBody,
  UpdateChartOfAccountBody,
  UpdateClientDocumentBody,
  UpdateClientInvoiceBody,
  UpdateClientReceiptBody,
  UpdateCompanyBody,
  UpdateCustomerBody,
  UpdateExpenseCategoryBody,
  UpdateJournalEntryBody,
  UpdateMasterSCBody,
  UpdateMasterStaffMemberBody,
  UpdateMasterSupplierBody,
  UpdatePayrollEntryBody,
  UpdateProjectBody,
  UpdatePromissoryNoteBody,
  UpdateScInvoiceBody,
  UpdateScPaymentBody,
  UpdateSubcontractorBody,
  UpdateSupplierBody,
  UpdateSupplierInvoiceBody,
  UpdateSupplierPaymentBody,
  UpdateTaxRateBody,
  UpdateTaxTypeBody,
  UpdateUserBody,
  UpdateVendorOrderBody,
  UploadUrlRequest,
  UploadUrlResponse,
  UpsertAccountMappingBody,
  UserPublic,
  VendorOrder,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Login with email and password
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginBody),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginBody>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login with email and password
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Logout current session
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout current session
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<AuthUser> => {
  return customFetch<AuthUser>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new account and company
 */
export const getSignupUrl = () => {
  return `/api/auth/signup`;
};

export const signup = async (
  signupBody: SignupBody,
  options?: RequestInit,
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getSignupUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(signupBody),
  });
};

export const getSignupMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signup>>,
    TError,
    { data: BodyType<SignupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signup>>,
  TError,
  { data: BodyType<SignupBody> },
  TContext
> => {
  const mutationKey = ["signup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signup>>,
    { data: BodyType<SignupBody> }
  > = (props) => {
    const { data } = props ?? {};

    return signup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof signup>>
>;
export type SignupMutationBody = BodyType<SignupBody>;
export type SignupMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register a new account and company
 */
export const useSignup = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signup>>,
    TError,
    { data: BodyType<SignupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof signup>>,
  TError,
  { data: BodyType<SignupBody> },
  TContext
> => {
  return useMutation(getSignupMutationOptions(options));
};

/**
 * @summary Switch session into a specific company context
 */
export const getSelectCompanyUrl = () => {
  return `/api/auth/select-company`;
};

export const selectCompany = async (
  selectCompanyBody: SelectCompanyBody,
  options?: RequestInit,
): Promise<SelectCompanyResponse> => {
  return customFetch<SelectCompanyResponse>(getSelectCompanyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(selectCompanyBody),
  });
};

export const getSelectCompanyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectCompany>>,
    TError,
    { data: BodyType<SelectCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof selectCompany>>,
  TError,
  { data: BodyType<SelectCompanyBody> },
  TContext
> => {
  const mutationKey = ["selectCompany"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof selectCompany>>,
    { data: BodyType<SelectCompanyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return selectCompany(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SelectCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof selectCompany>>
>;
export type SelectCompanyMutationBody = BodyType<SelectCompanyBody>;
export type SelectCompanyMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Switch session into a specific company context
 */
export const useSelectCompany = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof selectCompany>>,
    TError,
    { data: BodyType<SelectCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof selectCompany>>,
  TError,
  { data: BodyType<SelectCompanyBody> },
  TContext
> => {
  return useMutation(getSelectCompanyMutationOptions(options));
};

/**
 * @summary Send an email invitation to join a company
 */
export const getSendInviteUrl = () => {
  return `/api/auth/invite`;
};

export const sendInvite = async (
  inviteBody: InviteBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getSendInviteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(inviteBody),
  });
};

export const getSendInviteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInvite>>,
    TError,
    { data: BodyType<InviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendInvite>>,
  TError,
  { data: BodyType<InviteBody> },
  TContext
> => {
  const mutationKey = ["sendInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendInvite>>,
    { data: BodyType<InviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return sendInvite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendInvite>>
>;
export type SendInviteMutationBody = BodyType<InviteBody>;
export type SendInviteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send an email invitation to join a company
 */
export const useSendInvite = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendInvite>>,
    TError,
    { data: BodyType<InviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendInvite>>,
  TError,
  { data: BodyType<InviteBody> },
  TContext
> => {
  return useMutation(getSendInviteMutationOptions(options));
};

/**
 * @summary Look up an invitation by token
 */
export const getGetInviteUrl = (token: string) => {
  return `/api/auth/invite/${token}`;
};

export const getInvite = async (
  token: string,
  options?: RequestInit,
): Promise<InvitationItem> => {
  return customFetch<InvitationItem>(getGetInviteUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetInviteQueryKey = (token: string) => {
  return [`/api/auth/invite/${token}`] as const;
};

export const getGetInviteQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvite>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvite>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInviteQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvite>>> = ({
    signal,
  }) => getInvite(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getInvite>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetInviteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvite>>
>;
export type GetInviteQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Look up an invitation by token
 */

export function useGetInvite<
  TData = Awaited<ReturnType<typeof getInvite>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInvite>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInviteQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Accept an invitation and create account
 */
export const getAcceptInviteUrl = () => {
  return `/api/auth/accept-invite`;
};

export const acceptInvite = async (
  acceptInviteBody: AcceptInviteBody,
  options?: RequestInit,
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getAcceptInviteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptInviteBody),
  });
};

export const getAcceptInviteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  const mutationKey = ["acceptInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptInvite>>,
    { data: BodyType<AcceptInviteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptInvite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvite>>
>;
export type AcceptInviteMutationBody = BodyType<AcceptInviteBody>;
export type AcceptInviteMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Accept an invitation and create account
 */
export const useAcceptInvite = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { data: BodyType<AcceptInviteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { data: BodyType<AcceptInviteBody> },
  TContext
> => {
  return useMutation(getAcceptInviteMutationOptions(options));
};

/**
 * @summary List members of the current company
 */
export const getListMembersUrl = () => {
  return `/api/auth/members`;
};

export const listMembers = async (
  options?: RequestInit,
): Promise<MemberItem[]> => {
  return customFetch<MemberItem[]>(getListMembersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMembersQueryKey = () => {
  return [`/api/auth/members`] as const;
};

export const getListMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMembersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({
    signal,
  }) => listMembers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMembers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMembers>>
>;
export type ListMembersQueryError = ErrorType<unknown>;

/**
 * @summary List members of the current company
 */

export function useListMembers<
  TData = Awaited<ReturnType<typeof listMembers>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMembers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMembersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List pending invitations for the current company
 */
export const getListInvitationsUrl = () => {
  return `/api/auth/invitations`;
};

export const listInvitations = async (
  options?: RequestInit,
): Promise<InvitationItem[]> => {
  return customFetch<InvitationItem[]>(getListInvitationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListInvitationsQueryKey = () => {
  return [`/api/auth/invitations`] as const;
};

export const getListInvitationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvitations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvitationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvitations>>> = ({
    signal,
  }) => listInvitations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvitations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvitationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvitations>>
>;
export type ListInvitationsQueryError = ErrorType<unknown>;

/**
 * @summary List pending invitations for the current company
 */

export function useListInvitations<
  TData = Awaited<ReturnType<typeof listInvitations>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvitations>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvitationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Activate a paid account (or convert demo), with stubbed payment
 */
export const getActivateAccountUrl = () => {
  return `/api/auth/signup/activate`;
};

export const activateAccount = async (
  activateAccountBody: ActivateAccountBody,
  options?: RequestInit,
): Promise<LoginResponse> => {
  return customFetch<LoginResponse>(getActivateAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(activateAccountBody),
  });
};

export const getActivateAccountMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateAccount>>,
    TError,
    { data: BodyType<ActivateAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateAccount>>,
  TError,
  { data: BodyType<ActivateAccountBody> },
  TContext
> => {
  const mutationKey = ["activateAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateAccount>>,
    { data: BodyType<ActivateAccountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return activateAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateAccount>>
>;
export type ActivateAccountMutationBody = BodyType<ActivateAccountBody>;
export type ActivateAccountMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Activate a paid account (or convert demo), with stubbed payment
 */
export const useActivateAccount = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateAccount>>,
    TError,
    { data: BodyType<ActivateAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof activateAccount>>,
  TError,
  { data: BodyType<ActivateAccountBody> },
  TContext
> => {
  return useMutation(getActivateAccountMutationOptions(options));
};

/**
 * @summary Check if an email has an existing demo account
 */
export const getCheckDemoEmailUrl = (params: CheckDemoEmailParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/auth/check-demo?${stringifiedParams}`
    : `/api/auth/check-demo`;
};

export const checkDemoEmail = async (
  params: CheckDemoEmailParams,
  options?: RequestInit,
): Promise<CheckDemoResponse> => {
  return customFetch<CheckDemoResponse>(getCheckDemoEmailUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCheckDemoEmailQueryKey = (params?: CheckDemoEmailParams) => {
  return [`/api/auth/check-demo`, ...(params ? [params] : [])] as const;
};

export const getCheckDemoEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof checkDemoEmail>>,
  TError = ErrorType<unknown>,
>(
  params: CheckDemoEmailParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkDemoEmail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCheckDemoEmailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkDemoEmail>>> = ({
    signal,
  }) => checkDemoEmail(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof checkDemoEmail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CheckDemoEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkDemoEmail>>
>;
export type CheckDemoEmailQueryError = ErrorType<unknown>;

/**
 * @summary Check if an email has an existing demo account
 */

export function useCheckDemoEmail<
  TData = Awaited<ReturnType<typeof checkDemoEmail>>,
  TError = ErrorType<unknown>,
>(
  params: CheckDemoEmailParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof checkDemoEmail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCheckDemoEmailQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all demo leads (Super Admin only)
 */
export const getListLeadsUrl = () => {
  return `/api/auth/leads`;
};

export const listLeads = async (options?: RequestInit): Promise<DemoLead[]> => {
  return customFetch<DemoLead[]>(getListLeadsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListLeadsQueryKey = () => {
  return [`/api/auth/leads`] as const;
};

export const getListLeadsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLeads>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listLeads>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLeadsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLeads>>> = ({
    signal,
  }) => listLeads({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLeads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLeadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLeads>>
>;
export type ListLeadsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all demo leads (Super Admin only)
 */

export function useListLeads<
  TData = Awaited<ReturnType<typeof listLeads>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof listLeads>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLeadsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Complete the company setup wizard
 */
export const getCompleteSetupUrl = () => {
  return `/api/auth/setup`;
};

export const completeSetup = async (
  setupBody: SetupBody,
  options?: RequestInit,
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getCompleteSetupUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setupBody),
  });
};

export const getCompleteSetupMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSetup>>,
    TError,
    { data: BodyType<SetupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeSetup>>,
  TError,
  { data: BodyType<SetupBody> },
  TContext
> => {
  const mutationKey = ["completeSetup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeSetup>>,
    { data: BodyType<SetupBody> }
  > = (props) => {
    const { data } = props ?? {};

    return completeSetup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteSetupMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeSetup>>
>;
export type CompleteSetupMutationBody = BodyType<SetupBody>;
export type CompleteSetupMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Complete the company setup wizard
 */
export const useCompleteSetup = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeSetup>>,
    TError,
    { data: BodyType<SetupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeSetup>>,
  TError,
  { data: BodyType<SetupBody> },
  TContext
> => {
  return useMutation(getCompleteSetupMutationOptions(options));
};

/**
 * @summary List attachments (filtered by companyId and/or projectId query params)
 */
export const getListAttachmentsUrl = (params?: ListAttachmentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/attachments?${stringifiedParams}`
    : `/api/attachments`;
};

export const listAttachments = async (
  params?: ListAttachmentsParams,
  options?: RequestInit,
): Promise<Attachment[]> => {
  return customFetch<Attachment[]>(getListAttachmentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAttachmentsQueryKey = (params?: ListAttachmentsParams) => {
  return [`/api/attachments`, ...(params ? [params] : [])] as const;
};

export const getListAttachmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAttachments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAttachmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttachments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAttachmentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAttachments>>> = ({
    signal,
  }) => listAttachments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAttachments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAttachmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAttachments>>
>;
export type ListAttachmentsQueryError = ErrorType<unknown>;

/**
 * @summary List attachments (filtered by companyId and/or projectId query params)
 */

export function useListAttachments<
  TData = Awaited<ReturnType<typeof listAttachments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAttachmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAttachments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAttachmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Record a new attachment
 */
export const getCreateAttachmentUrl = () => {
  return `/api/attachments`;
};

export const createAttachment = async (
  createAttachmentBody: CreateAttachmentBody,
  options?: RequestInit,
): Promise<Attachment> => {
  return customFetch<Attachment>(getCreateAttachmentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createAttachmentBody),
  });
};

export const getCreateAttachmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttachment>>,
    TError,
    { data: BodyType<CreateAttachmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAttachment>>,
  TError,
  { data: BodyType<CreateAttachmentBody> },
  TContext
> => {
  const mutationKey = ["createAttachment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAttachment>>,
    { data: BodyType<CreateAttachmentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createAttachment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAttachment>>
>;
export type CreateAttachmentMutationBody = BodyType<CreateAttachmentBody>;
export type CreateAttachmentMutationError = ErrorType<unknown>;

/**
 * @summary Record a new attachment
 */
export const useCreateAttachment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAttachment>>,
    TError,
    { data: BodyType<CreateAttachmentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAttachment>>,
  TError,
  { data: BodyType<CreateAttachmentBody> },
  TContext
> => {
  return useMutation(getCreateAttachmentMutationOptions(options));
};

/**
 * @summary Delete an attachment
 */
export const getDeleteAttachmentUrl = (
  id: string,
  params?: DeleteAttachmentParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/attachments/${id}?${stringifiedParams}`
    : `/api/attachments/${id}`;
};

export const deleteAttachment = async (
  id: string,
  params?: DeleteAttachmentParams,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteAttachmentUrl(id, params), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAttachmentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAttachment>>,
    TError,
    { id: string; params?: DeleteAttachmentParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAttachment>>,
  TError,
  { id: string; params?: DeleteAttachmentParams },
  TContext
> => {
  const mutationKey = ["deleteAttachment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAttachment>>,
    { id: string; params?: DeleteAttachmentParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return deleteAttachment(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAttachment>>
>;

export type DeleteAttachmentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete an attachment
 */
export const useDeleteAttachment = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAttachment>>,
    TError,
    { id: string; params?: DeleteAttachmentParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAttachment>>,
  TError,
  { id: string; params?: DeleteAttachmentParams },
  TContext
> => {
  return useMutation(getDeleteAttachmentMutationOptions(options));
};

/**
 * @summary List all companies
 */
export const getListCompaniesUrl = () => {
  return `/api/companies`;
};

export const listCompanies = async (
  options?: RequestInit,
): Promise<Company[]> => {
  return customFetch<Company[]>(getListCompaniesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCompaniesQueryKey = () => {
  return [`/api/companies`] as const;
};

export const getListCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCompanies>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCompanies>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCompaniesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCompanies>>> = ({
    signal,
  }) => listCompanies({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCompanies>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCompanies>>
>;
export type ListCompaniesQueryError = ErrorType<unknown>;

/**
 * @summary List all companies
 */

export function useListCompanies<
  TData = Awaited<ReturnType<typeof listCompanies>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCompanies>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCompaniesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a company
 */
export const getCreateCompanyUrl = () => {
  return `/api/companies`;
};

export const createCompany = async (
  createCompanyBody: CreateCompanyBody,
  options?: RequestInit,
): Promise<Company> => {
  return customFetch<Company>(getCreateCompanyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCompanyBody),
  });
};

export const getCreateCompanyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompany>>,
    TError,
    { data: BodyType<CreateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCompany>>,
  TError,
  { data: BodyType<CreateCompanyBody> },
  TContext
> => {
  const mutationKey = ["createCompany"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCompany>>,
    { data: BodyType<CreateCompanyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCompany(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCompany>>
>;
export type CreateCompanyMutationBody = BodyType<CreateCompanyBody>;
export type CreateCompanyMutationError = ErrorType<unknown>;

/**
 * @summary Create a company
 */
export const useCreateCompany = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCompany>>,
    TError,
    { data: BodyType<CreateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCompany>>,
  TError,
  { data: BodyType<CreateCompanyBody> },
  TContext
> => {
  return useMutation(getCreateCompanyMutationOptions(options));
};

export const getGetCompanyUrl = (id: string) => {
  return `/api/companies/${id}`;
};

export const getCompany = async (
  id: string,
  options?: RequestInit,
): Promise<Company> => {
  return customFetch<Company>(getGetCompanyUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCompanyQueryKey = (id: string) => {
  return [`/api/companies/${id}`] as const;
};

export const getGetCompanyQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompany>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCompany>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompanyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({
    signal,
  }) => getCompany(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompany>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompanyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompany>>
>;
export type GetCompanyQueryError = ErrorType<ErrorResponse>;

export function useGetCompany<
  TData = Awaited<ReturnType<typeof getCompany>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCompany>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCompanyQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateCompanyUrl = (id: string) => {
  return `/api/companies/${id}`;
};

export const updateCompany = async (
  id: string,
  updateCompanyBody: UpdateCompanyBody,
  options?: RequestInit,
): Promise<Company> => {
  return customFetch<Company>(getUpdateCompanyUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCompanyBody),
  });
};

export const getUpdateCompanyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCompany>>,
    TError,
    { id: string; data: BodyType<UpdateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCompany>>,
  TError,
  { id: string; data: BodyType<UpdateCompanyBody> },
  TContext
> => {
  const mutationKey = ["updateCompany"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCompany>>,
    { id: string; data: BodyType<UpdateCompanyBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCompany(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCompany>>
>;
export type UpdateCompanyMutationBody = BodyType<UpdateCompanyBody>;
export type UpdateCompanyMutationError = ErrorType<unknown>;

export const useUpdateCompany = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCompany>>,
    TError,
    { id: string; data: BodyType<UpdateCompanyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCompany>>,
  TError,
  { id: string; data: BodyType<UpdateCompanyBody> },
  TContext
> => {
  return useMutation(getUpdateCompanyMutationOptions(options));
};

/**
 * @summary Delete a company (Super Admin only)
 */
export const getDeleteCompanyUrl = (id: string) => {
  return `/api/companies/${id}`;
};

export const deleteCompany = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCompanyUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCompanyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCompany>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCompany>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteCompany"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCompany>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCompany(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCompanyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCompany>>
>;

export type DeleteCompanyMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a company (Super Admin only)
 */
export const useDeleteCompany = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCompany>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCompany>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteCompanyMutationOptions(options));
};

/**
 * @summary List users
 */
export const getListUsersUrl = (params?: ListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/users?${stringifiedParams}`
    : `/api/users`;
};

export const listUsers = async (
  params?: ListUsersParams,
  options?: RequestInit,
): Promise<UserPublic[]> => {
  return customFetch<UserPublic[]>(getListUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListUsersQueryKey = (params?: ListUsersParams) => {
  return [`/api/users`, ...(params ? [params] : [])] as const;
};

export const getListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({
    signal,
  }) => listUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsers>>
>;
export type ListUsersQueryError = ErrorType<unknown>;

/**
 * @summary List users
 */

export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateUserUrl = () => {
  return `/api/users`;
};

export const createUser = async (
  createUserBody: CreateUserBody,
  options?: RequestInit,
): Promise<UserPublic> => {
  return customFetch<UserPublic>(getCreateUserUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createUserBody),
  });
};

export const getCreateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: BodyType<CreateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: BodyType<CreateUserBody> },
  TContext
> => {
  const mutationKey = ["createUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createUser>>,
    { data: BodyType<CreateUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof createUser>>
>;
export type CreateUserMutationBody = BodyType<CreateUserBody>;
export type CreateUserMutationError = ErrorType<unknown>;

export const useCreateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createUser>>,
    TError,
    { data: BodyType<CreateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createUser>>,
  TError,
  { data: BodyType<CreateUserBody> },
  TContext
> => {
  return useMutation(getCreateUserMutationOptions(options));
};

export const getUpdateUserUrl = (id: string) => {
  return `/api/users/${id}`;
};

export const updateUser = async (
  id: string,
  updateUserBody: UpdateUserBody,
  options?: RequestInit,
): Promise<UserPublic> => {
  return customFetch<UserPublic>(getUpdateUserUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserBody),
  });
};

export const getUpdateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: string; data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: string; data: BodyType<UpdateUserBody> },
  TContext
> => {
  const mutationKey = ["updateUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUser>>,
    { id: string; data: BodyType<UpdateUserBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUser>>
>;
export type UpdateUserMutationBody = BodyType<UpdateUserBody>;
export type UpdateUserMutationError = ErrorType<unknown>;

export const useUpdateUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUser>>,
    TError,
    { id: string; data: BodyType<UpdateUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUser>>,
  TError,
  { id: string; data: BodyType<UpdateUserBody> },
  TContext
> => {
  return useMutation(getUpdateUserMutationOptions(options));
};

export const getDeleteUserUrl = (id: string) => {
  return `/api/users/${id}`;
};

export const deleteUser = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteUserUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUser>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteUser(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUser>>
>;

export type DeleteUserMutationError = ErrorType<unknown>;

export const useDeleteUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUser>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteUserMutationOptions(options));
};

export const getGetCompanyBySlugUrl = (slug: string) => {
  return `/api/companies/by-slug/${slug}`;
};

export const getCompanyBySlug = async (
  slug: string,
  options?: RequestInit,
): Promise<CompanyBySlugResponse> => {
  return customFetch<CompanyBySlugResponse>(getGetCompanyBySlugUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetCompanyBySlugQueryKey = (slug: string) => {
  return [`/api/companies/by-slug/${slug}`] as const;
};

export const getGetCompanyBySlugQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompanyBySlug>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCompanyBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompanyBySlugQueryKey(slug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCompanyBySlug>>
  > = ({ signal }) => getCompanyBySlug(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!slug,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompanyBySlug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompanyBySlugQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompanyBySlug>>
>;
export type GetCompanyBySlugQueryError = ErrorType<ErrorResponse>;

export function useGetCompanyBySlug<
  TData = Awaited<ReturnType<typeof getCompanyBySlug>>,
  TError = ErrorType<ErrorResponse>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCompanyBySlug>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCompanyBySlugQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListProjectsUrl = (params?: ListProjectsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/projects?${stringifiedParams}`
    : `/api/projects`;
};

export const listProjects = async (
  params?: ListProjectsParams,
  options?: RequestInit,
): Promise<Project[]> => {
  return customFetch<Project[]>(getListProjectsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListProjectsQueryKey = (params?: ListProjectsParams) => {
  return [`/api/projects`, ...(params ? [params] : [])] as const;
};

export const getListProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProjectsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProjects>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({
    signal,
  }) => listProjects(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProjects>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProjects>>
>;
export type ListProjectsQueryError = ErrorType<unknown>;

export function useListProjects<
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProjectsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProjects>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateProjectUrl = () => {
  return `/api/projects`;
};

export const createProject = async (
  createProjectBody: CreateProjectBody,
  options?: RequestInit,
): Promise<Project> => {
  return customFetch<Project>(getCreateProjectUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProjectBody),
  });
};

export const getCreateProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    { data: BodyType<CreateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: BodyType<CreateProjectBody> },
  TContext
> => {
  const mutationKey = ["createProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProject>>,
    { data: BodyType<CreateProjectBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createProject(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProject>>
>;
export type CreateProjectMutationBody = BodyType<CreateProjectBody>;
export type CreateProjectMutationError = ErrorType<unknown>;

export const useCreateProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    { data: BodyType<CreateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: BodyType<CreateProjectBody> },
  TContext
> => {
  return useMutation(getCreateProjectMutationOptions(options));
};

export const getGetProjectUrl = (id: string) => {
  return `/api/projects/${id}`;
};

export const getProject = async (
  id: string,
  options?: RequestInit,
): Promise<Project> => {
  return customFetch<Project>(getGetProjectUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProjectQueryKey = (id: string) => {
  return [`/api/projects/${id}`] as const;
};

export const getGetProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({
    signal,
  }) => getProject(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProject>>
>;
export type GetProjectQueryError = ErrorType<unknown>;

export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateProjectUrl = (id: string) => {
  return `/api/projects/${id}`;
};

export const updateProject = async (
  id: string,
  updateProjectBody: UpdateProjectBody,
  options?: RequestInit,
): Promise<Project> => {
  return customFetch<Project>(getUpdateProjectUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProjectBody),
  });
};

export const getUpdateProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProject>>,
    TError,
    { id: string; data: BodyType<UpdateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProject>>,
  TError,
  { id: string; data: BodyType<UpdateProjectBody> },
  TContext
> => {
  const mutationKey = ["updateProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProject>>,
    { id: string; data: BodyType<UpdateProjectBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProject(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProject>>
>;
export type UpdateProjectMutationBody = BodyType<UpdateProjectBody>;
export type UpdateProjectMutationError = ErrorType<unknown>;

export const useUpdateProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProject>>,
    TError,
    { id: string; data: BodyType<UpdateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProject>>,
  TError,
  { id: string; data: BodyType<UpdateProjectBody> },
  TContext
> => {
  return useMutation(getUpdateProjectMutationOptions(options));
};

export const getDeleteProjectUrl = (id: string) => {
  return `/api/projects/${id}`;
};

export const deleteProject = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteProjectUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProject>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProject>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProject>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProject(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProject>>
>;

export type DeleteProjectMutationError = ErrorType<unknown>;

export const useDeleteProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProject>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProject>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteProjectMutationOptions(options));
};

export const getListSubcontractorsUrl = (params?: ListSubcontractorsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/subcontractors?${stringifiedParams}`
    : `/api/subcontractors`;
};

export const listSubcontractors = async (
  params?: ListSubcontractorsParams,
  options?: RequestInit,
): Promise<Subcontractor[]> => {
  return customFetch<Subcontractor[]>(getListSubcontractorsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSubcontractorsQueryKey = (
  params?: ListSubcontractorsParams,
) => {
  return [`/api/subcontractors`, ...(params ? [params] : [])] as const;
};

export const getListSubcontractorsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSubcontractors>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSubcontractorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSubcontractors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSubcontractorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSubcontractors>>
  > = ({ signal }) => listSubcontractors(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSubcontractors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSubcontractorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSubcontractors>>
>;
export type ListSubcontractorsQueryError = ErrorType<unknown>;

export function useListSubcontractors<
  TData = Awaited<ReturnType<typeof listSubcontractors>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSubcontractorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSubcontractors>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSubcontractorsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateSubcontractorUrl = () => {
  return `/api/subcontractors`;
};

export const createSubcontractor = async (
  createSubcontractorBody: CreateSubcontractorBody,
  options?: RequestInit,
): Promise<Subcontractor> => {
  return customFetch<Subcontractor>(getCreateSubcontractorUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSubcontractorBody),
  });
};

export const getCreateSubcontractorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubcontractor>>,
    TError,
    { data: BodyType<CreateSubcontractorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSubcontractor>>,
  TError,
  { data: BodyType<CreateSubcontractorBody> },
  TContext
> => {
  const mutationKey = ["createSubcontractor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSubcontractor>>,
    { data: BodyType<CreateSubcontractorBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSubcontractor(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSubcontractorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSubcontractor>>
>;
export type CreateSubcontractorMutationBody = BodyType<CreateSubcontractorBody>;
export type CreateSubcontractorMutationError = ErrorType<unknown>;

export const useCreateSubcontractor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubcontractor>>,
    TError,
    { data: BodyType<CreateSubcontractorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSubcontractor>>,
  TError,
  { data: BodyType<CreateSubcontractorBody> },
  TContext
> => {
  return useMutation(getCreateSubcontractorMutationOptions(options));
};

export const getUpdateSubcontractorUrl = (id: string) => {
  return `/api/subcontractors/${id}`;
};

export const updateSubcontractor = async (
  id: string,
  updateSubcontractorBody: UpdateSubcontractorBody,
  options?: RequestInit,
): Promise<Subcontractor> => {
  return customFetch<Subcontractor>(getUpdateSubcontractorUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSubcontractorBody),
  });
};

export const getUpdateSubcontractorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubcontractor>>,
    TError,
    { id: string; data: BodyType<UpdateSubcontractorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubcontractor>>,
  TError,
  { id: string; data: BodyType<UpdateSubcontractorBody> },
  TContext
> => {
  const mutationKey = ["updateSubcontractor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubcontractor>>,
    { id: string; data: BodyType<UpdateSubcontractorBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSubcontractor(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSubcontractorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubcontractor>>
>;
export type UpdateSubcontractorMutationBody = BodyType<UpdateSubcontractorBody>;
export type UpdateSubcontractorMutationError = ErrorType<unknown>;

export const useUpdateSubcontractor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubcontractor>>,
    TError,
    { id: string; data: BodyType<UpdateSubcontractorBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSubcontractor>>,
  TError,
  { id: string; data: BodyType<UpdateSubcontractorBody> },
  TContext
> => {
  return useMutation(getUpdateSubcontractorMutationOptions(options));
};

export const getDeleteSubcontractorUrl = (id: string) => {
  return `/api/subcontractors/${id}`;
};

export const deleteSubcontractor = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSubcontractorUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSubcontractorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSubcontractor>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSubcontractor>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSubcontractor"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSubcontractor>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSubcontractor(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSubcontractorMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSubcontractor>>
>;

export type DeleteSubcontractorMutationError = ErrorType<unknown>;

export const useDeleteSubcontractor = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSubcontractor>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSubcontractor>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSubcontractorMutationOptions(options));
};

export const getListSuppliersUrl = (params?: ListSuppliersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/suppliers?${stringifiedParams}`
    : `/api/suppliers`;
};

export const listSuppliers = async (
  params?: ListSuppliersParams,
  options?: RequestInit,
): Promise<Supplier[]> => {
  return customFetch<Supplier[]>(getListSuppliersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSuppliersQueryKey = (params?: ListSuppliersParams) => {
  return [`/api/suppliers`, ...(params ? [params] : [])] as const;
};

export const getListSuppliersQueryOptions = <
  TData = Awaited<ReturnType<typeof listSuppliers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSuppliersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSuppliers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSuppliersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuppliers>>> = ({
    signal,
  }) => listSuppliers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSuppliers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSuppliersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSuppliers>>
>;
export type ListSuppliersQueryError = ErrorType<unknown>;

export function useListSuppliers<
  TData = Awaited<ReturnType<typeof listSuppliers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSuppliersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSuppliers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSuppliersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateSupplierUrl = () => {
  return `/api/suppliers`;
};

export const createSupplier = async (
  createSupplierBody: CreateSupplierBody,
  options?: RequestInit,
): Promise<Supplier> => {
  return customFetch<Supplier>(getCreateSupplierUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSupplierBody),
  });
};

export const getCreateSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplier>>,
    TError,
    { data: BodyType<CreateSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSupplier>>,
  TError,
  { data: BodyType<CreateSupplierBody> },
  TContext
> => {
  const mutationKey = ["createSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSupplier>>,
    { data: BodyType<CreateSupplierBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSupplier(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSupplier>>
>;
export type CreateSupplierMutationBody = BodyType<CreateSupplierBody>;
export type CreateSupplierMutationError = ErrorType<unknown>;

export const useCreateSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplier>>,
    TError,
    { data: BodyType<CreateSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSupplier>>,
  TError,
  { data: BodyType<CreateSupplierBody> },
  TContext
> => {
  return useMutation(getCreateSupplierMutationOptions(options));
};

export const getUpdateSupplierUrl = (id: string) => {
  return `/api/suppliers/${id}`;
};

export const updateSupplier = async (
  id: string,
  updateSupplierBody: UpdateSupplierBody,
  options?: RequestInit,
): Promise<Supplier> => {
  return customFetch<Supplier>(getUpdateSupplierUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSupplierBody),
  });
};

export const getUpdateSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplier>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSupplier>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierBody> },
  TContext
> => {
  const mutationKey = ["updateSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSupplier>>,
    { id: string; data: BodyType<UpdateSupplierBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSupplier(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSupplier>>
>;
export type UpdateSupplierMutationBody = BodyType<UpdateSupplierBody>;
export type UpdateSupplierMutationError = ErrorType<unknown>;

export const useUpdateSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplier>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSupplier>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierBody> },
  TContext
> => {
  return useMutation(getUpdateSupplierMutationOptions(options));
};

export const getDeleteSupplierUrl = (id: string) => {
  return `/api/suppliers/${id}`;
};

export const deleteSupplier = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplier>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSupplier>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSupplier>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSupplier(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSupplier>>
>;

export type DeleteSupplierMutationError = ErrorType<unknown>;

export const useDeleteSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplier>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSupplier>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSupplierMutationOptions(options));
};

export const getListClientInvoicesUrl = (params?: ListClientInvoicesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/client-invoices?${stringifiedParams}`
    : `/api/client-invoices`;
};

export const listClientInvoices = async (
  params?: ListClientInvoicesParams,
  options?: RequestInit,
): Promise<ClientInvoice[]> => {
  return customFetch<ClientInvoice[]>(getListClientInvoicesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListClientInvoicesQueryKey = (
  params?: ListClientInvoicesParams,
) => {
  return [`/api/client-invoices`, ...(params ? [params] : [])] as const;
};

export const getListClientInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listClientInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClientInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListClientInvoicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listClientInvoices>>
  > = ({ signal }) => listClientInvoices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClientInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClientInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClientInvoices>>
>;
export type ListClientInvoicesQueryError = ErrorType<unknown>;

export function useListClientInvoices<
  TData = Awaited<ReturnType<typeof listClientInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClientInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClientInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateClientInvoiceUrl = () => {
  return `/api/client-invoices`;
};

export const createClientInvoice = async (
  createClientInvoiceBody: CreateClientInvoiceBody,
  options?: RequestInit,
): Promise<ClientInvoice> => {
  return customFetch<ClientInvoice>(getCreateClientInvoiceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createClientInvoiceBody),
  });
};

export const getCreateClientInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientInvoice>>,
    TError,
    { data: BodyType<CreateClientInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClientInvoice>>,
  TError,
  { data: BodyType<CreateClientInvoiceBody> },
  TContext
> => {
  const mutationKey = ["createClientInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClientInvoice>>,
    { data: BodyType<CreateClientInvoiceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createClientInvoice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClientInvoice>>
>;
export type CreateClientInvoiceMutationBody = BodyType<CreateClientInvoiceBody>;
export type CreateClientInvoiceMutationError = ErrorType<unknown>;

export const useCreateClientInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientInvoice>>,
    TError,
    { data: BodyType<CreateClientInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClientInvoice>>,
  TError,
  { data: BodyType<CreateClientInvoiceBody> },
  TContext
> => {
  return useMutation(getCreateClientInvoiceMutationOptions(options));
};

export const getUpdateClientInvoiceUrl = (id: string) => {
  return `/api/client-invoices/${id}`;
};

export const updateClientInvoice = async (
  id: string,
  updateClientInvoiceBody: UpdateClientInvoiceBody,
  options?: RequestInit,
): Promise<ClientInvoice> => {
  return customFetch<ClientInvoice>(getUpdateClientInvoiceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateClientInvoiceBody),
  });
};

export const getUpdateClientInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientInvoice>>,
    TError,
    { id: string; data: BodyType<UpdateClientInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClientInvoice>>,
  TError,
  { id: string; data: BodyType<UpdateClientInvoiceBody> },
  TContext
> => {
  const mutationKey = ["updateClientInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClientInvoice>>,
    { id: string; data: BodyType<UpdateClientInvoiceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateClientInvoice(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClientInvoice>>
>;
export type UpdateClientInvoiceMutationBody = BodyType<UpdateClientInvoiceBody>;
export type UpdateClientInvoiceMutationError = ErrorType<unknown>;

export const useUpdateClientInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientInvoice>>,
    TError,
    { id: string; data: BodyType<UpdateClientInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClientInvoice>>,
  TError,
  { id: string; data: BodyType<UpdateClientInvoiceBody> },
  TContext
> => {
  return useMutation(getUpdateClientInvoiceMutationOptions(options));
};

export const getDeleteClientInvoiceUrl = (id: string) => {
  return `/api/client-invoices/${id}`;
};

export const deleteClientInvoice = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteClientInvoiceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteClientInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClientInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteClientInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClientInvoice>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteClientInvoice(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClientInvoice>>
>;

export type DeleteClientInvoiceMutationError = ErrorType<unknown>;

export const useDeleteClientInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClientInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteClientInvoiceMutationOptions(options));
};

export const getListClientDocumentsUrl = (
  params?: ListClientDocumentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/client-documents?${stringifiedParams}`
    : `/api/client-documents`;
};

export const listClientDocuments = async (
  params?: ListClientDocumentsParams,
  options?: RequestInit,
): Promise<ClientDocument[]> => {
  return customFetch<ClientDocument[]>(getListClientDocumentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListClientDocumentsQueryKey = (
  params?: ListClientDocumentsParams,
) => {
  return [`/api/client-documents`, ...(params ? [params] : [])] as const;
};

export const getListClientDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listClientDocuments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClientDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListClientDocumentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listClientDocuments>>
  > = ({ signal }) =>
    listClientDocuments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClientDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClientDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClientDocuments>>
>;
export type ListClientDocumentsQueryError = ErrorType<unknown>;

export function useListClientDocuments<
  TData = Awaited<ReturnType<typeof listClientDocuments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClientDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClientDocumentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateClientDocumentUrl = () => {
  return `/api/client-documents`;
};

export const createClientDocument = async (
  createClientDocumentBody: CreateClientDocumentBody,
  options?: RequestInit,
): Promise<ClientDocument> => {
  return customFetch<ClientDocument>(getCreateClientDocumentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createClientDocumentBody),
  });
};

export const getCreateClientDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientDocument>>,
    TError,
    { data: BodyType<CreateClientDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClientDocument>>,
  TError,
  { data: BodyType<CreateClientDocumentBody> },
  TContext
> => {
  const mutationKey = ["createClientDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClientDocument>>,
    { data: BodyType<CreateClientDocumentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createClientDocument(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClientDocument>>
>;
export type CreateClientDocumentMutationBody =
  BodyType<CreateClientDocumentBody>;
export type CreateClientDocumentMutationError = ErrorType<unknown>;

export const useCreateClientDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientDocument>>,
    TError,
    { data: BodyType<CreateClientDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClientDocument>>,
  TError,
  { data: BodyType<CreateClientDocumentBody> },
  TContext
> => {
  return useMutation(getCreateClientDocumentMutationOptions(options));
};

export const getUpdateClientDocumentUrl = (id: string) => {
  return `/api/client-documents/${id}`;
};

export const updateClientDocument = async (
  id: string,
  updateClientDocumentBody: UpdateClientDocumentBody,
  options?: RequestInit,
): Promise<ClientDocument> => {
  return customFetch<ClientDocument>(getUpdateClientDocumentUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateClientDocumentBody),
  });
};

export const getUpdateClientDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientDocument>>,
    TError,
    { id: string; data: BodyType<UpdateClientDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClientDocument>>,
  TError,
  { id: string; data: BodyType<UpdateClientDocumentBody> },
  TContext
> => {
  const mutationKey = ["updateClientDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClientDocument>>,
    { id: string; data: BodyType<UpdateClientDocumentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateClientDocument(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClientDocument>>
>;
export type UpdateClientDocumentMutationBody =
  BodyType<UpdateClientDocumentBody>;
export type UpdateClientDocumentMutationError = ErrorType<unknown>;

export const useUpdateClientDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientDocument>>,
    TError,
    { id: string; data: BodyType<UpdateClientDocumentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClientDocument>>,
  TError,
  { id: string; data: BodyType<UpdateClientDocumentBody> },
  TContext
> => {
  return useMutation(getUpdateClientDocumentMutationOptions(options));
};

export const getDeleteClientDocumentUrl = (id: string) => {
  return `/api/client-documents/${id}`;
};

export const deleteClientDocument = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteClientDocumentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteClientDocumentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientDocument>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClientDocument>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteClientDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClientDocument>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteClientDocument(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClientDocument>>
>;

export type DeleteClientDocumentMutationError = ErrorType<unknown>;

export const useDeleteClientDocument = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientDocument>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClientDocument>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteClientDocumentMutationOptions(options));
};

export const getConvertClientDocumentToInvoiceUrl = (id: string) => {
  return `/api/client-documents/${id}/convert-to-invoice`;
};

export const convertClientDocumentToInvoice = async (
  id: string,
  options?: RequestInit,
): Promise<ConvertClientDocumentToInvoice201> => {
  return customFetch<ConvertClientDocumentToInvoice201>(
    getConvertClientDocumentToInvoiceUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getConvertClientDocumentToInvoiceMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof convertClientDocumentToInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof convertClientDocumentToInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["convertClientDocumentToInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof convertClientDocumentToInvoice>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return convertClientDocumentToInvoice(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConvertClientDocumentToInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof convertClientDocumentToInvoice>>
>;

export type ConvertClientDocumentToInvoiceMutationError =
  ErrorType<ErrorResponse>;

export const useConvertClientDocumentToInvoice = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof convertClientDocumentToInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof convertClientDocumentToInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getConvertClientDocumentToInvoiceMutationOptions(options));
};

export const getListVendorOrdersUrl = (params?: ListVendorOrdersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vendor-orders?${stringifiedParams}`
    : `/api/vendor-orders`;
};

export const listVendorOrders = async (
  params?: ListVendorOrdersParams,
  options?: RequestInit,
): Promise<VendorOrder[]> => {
  return customFetch<VendorOrder[]>(getListVendorOrdersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVendorOrdersQueryKey = (
  params?: ListVendorOrdersParams,
) => {
  return [`/api/vendor-orders`, ...(params ? [params] : [])] as const;
};

export const getListVendorOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listVendorOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVendorOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVendorOrdersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVendorOrders>>
  > = ({ signal }) => listVendorOrders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVendorOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVendorOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVendorOrders>>
>;
export type ListVendorOrdersQueryError = ErrorType<unknown>;

export function useListVendorOrders<
  TData = Awaited<ReturnType<typeof listVendorOrders>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVendorOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVendorOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVendorOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateVendorOrderUrl = () => {
  return `/api/vendor-orders`;
};

export const createVendorOrder = async (
  createVendorOrderBody: CreateVendorOrderBody,
  options?: RequestInit,
): Promise<VendorOrder> => {
  return customFetch<VendorOrder>(getCreateVendorOrderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createVendorOrderBody),
  });
};

export const getCreateVendorOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorOrder>>,
    TError,
    { data: BodyType<CreateVendorOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVendorOrder>>,
  TError,
  { data: BodyType<CreateVendorOrderBody> },
  TContext
> => {
  const mutationKey = ["createVendorOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVendorOrder>>,
    { data: BodyType<CreateVendorOrderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createVendorOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVendorOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVendorOrder>>
>;
export type CreateVendorOrderMutationBody = BodyType<CreateVendorOrderBody>;
export type CreateVendorOrderMutationError = ErrorType<unknown>;

export const useCreateVendorOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendorOrder>>,
    TError,
    { data: BodyType<CreateVendorOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createVendorOrder>>,
  TError,
  { data: BodyType<CreateVendorOrderBody> },
  TContext
> => {
  return useMutation(getCreateVendorOrderMutationOptions(options));
};

export const getUpdateVendorOrderUrl = (id: string) => {
  return `/api/vendor-orders/${id}`;
};

export const updateVendorOrder = async (
  id: string,
  updateVendorOrderBody: UpdateVendorOrderBody,
  options?: RequestInit,
): Promise<VendorOrder> => {
  return customFetch<VendorOrder>(getUpdateVendorOrderUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVendorOrderBody),
  });
};

export const getUpdateVendorOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorOrder>>,
    TError,
    { id: string; data: BodyType<UpdateVendorOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVendorOrder>>,
  TError,
  { id: string; data: BodyType<UpdateVendorOrderBody> },
  TContext
> => {
  const mutationKey = ["updateVendorOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVendorOrder>>,
    { id: string; data: BodyType<UpdateVendorOrderBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVendorOrder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVendorOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVendorOrder>>
>;
export type UpdateVendorOrderMutationBody = BodyType<UpdateVendorOrderBody>;
export type UpdateVendorOrderMutationError = ErrorType<unknown>;

export const useUpdateVendorOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendorOrder>>,
    TError,
    { id: string; data: BodyType<UpdateVendorOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVendorOrder>>,
  TError,
  { id: string; data: BodyType<UpdateVendorOrderBody> },
  TContext
> => {
  return useMutation(getUpdateVendorOrderMutationOptions(options));
};

export const getDeleteVendorOrderUrl = (id: string) => {
  return `/api/vendor-orders/${id}`;
};

export const deleteVendorOrder = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteVendorOrderUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteVendorOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorOrder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVendorOrder>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteVendorOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVendorOrder>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteVendorOrder(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVendorOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVendorOrder>>
>;

export type DeleteVendorOrderMutationError = ErrorType<unknown>;

export const useDeleteVendorOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVendorOrder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteVendorOrder>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteVendorOrderMutationOptions(options));
};

export const getListClientReceiptsUrl = (params?: ListClientReceiptsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/client-receipts?${stringifiedParams}`
    : `/api/client-receipts`;
};

export const listClientReceipts = async (
  params?: ListClientReceiptsParams,
  options?: RequestInit,
): Promise<ClientReceipt[]> => {
  return customFetch<ClientReceipt[]>(getListClientReceiptsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListClientReceiptsQueryKey = (
  params?: ListClientReceiptsParams,
) => {
  return [`/api/client-receipts`, ...(params ? [params] : [])] as const;
};

export const getListClientReceiptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listClientReceipts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientReceiptsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClientReceipts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListClientReceiptsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listClientReceipts>>
  > = ({ signal }) => listClientReceipts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listClientReceipts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListClientReceiptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listClientReceipts>>
>;
export type ListClientReceiptsQueryError = ErrorType<unknown>;

export function useListClientReceipts<
  TData = Awaited<ReturnType<typeof listClientReceipts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListClientReceiptsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listClientReceipts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListClientReceiptsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateClientReceiptUrl = () => {
  return `/api/client-receipts`;
};

export const createClientReceipt = async (
  createClientReceiptBody: CreateClientReceiptBody,
  options?: RequestInit,
): Promise<ClientReceipt> => {
  return customFetch<ClientReceipt>(getCreateClientReceiptUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createClientReceiptBody),
  });
};

export const getCreateClientReceiptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientReceipt>>,
    TError,
    { data: BodyType<CreateClientReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createClientReceipt>>,
  TError,
  { data: BodyType<CreateClientReceiptBody> },
  TContext
> => {
  const mutationKey = ["createClientReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createClientReceipt>>,
    { data: BodyType<CreateClientReceiptBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createClientReceipt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateClientReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof createClientReceipt>>
>;
export type CreateClientReceiptMutationBody = BodyType<CreateClientReceiptBody>;
export type CreateClientReceiptMutationError = ErrorType<unknown>;

export const useCreateClientReceipt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createClientReceipt>>,
    TError,
    { data: BodyType<CreateClientReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createClientReceipt>>,
  TError,
  { data: BodyType<CreateClientReceiptBody> },
  TContext
> => {
  return useMutation(getCreateClientReceiptMutationOptions(options));
};

export const getUpdateClientReceiptUrl = (id: string) => {
  return `/api/client-receipts/${id}`;
};

export const updateClientReceipt = async (
  id: string,
  updateClientReceiptBody: UpdateClientReceiptBody,
  options?: RequestInit,
): Promise<ClientReceipt> => {
  return customFetch<ClientReceipt>(getUpdateClientReceiptUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateClientReceiptBody),
  });
};

export const getUpdateClientReceiptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientReceipt>>,
    TError,
    { id: string; data: BodyType<UpdateClientReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateClientReceipt>>,
  TError,
  { id: string; data: BodyType<UpdateClientReceiptBody> },
  TContext
> => {
  const mutationKey = ["updateClientReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateClientReceipt>>,
    { id: string; data: BodyType<UpdateClientReceiptBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateClientReceipt(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateClientReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateClientReceipt>>
>;
export type UpdateClientReceiptMutationBody = BodyType<UpdateClientReceiptBody>;
export type UpdateClientReceiptMutationError = ErrorType<unknown>;

export const useUpdateClientReceipt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateClientReceipt>>,
    TError,
    { id: string; data: BodyType<UpdateClientReceiptBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateClientReceipt>>,
  TError,
  { id: string; data: BodyType<UpdateClientReceiptBody> },
  TContext
> => {
  return useMutation(getUpdateClientReceiptMutationOptions(options));
};

export const getDeleteClientReceiptUrl = (id: string) => {
  return `/api/client-receipts/${id}`;
};

export const deleteClientReceipt = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteClientReceiptUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteClientReceiptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientReceipt>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClientReceipt>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteClientReceipt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClientReceipt>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteClientReceipt(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClientReceipt>>
>;

export type DeleteClientReceiptMutationError = ErrorType<unknown>;

export const useDeleteClientReceipt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientReceipt>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteClientReceipt>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteClientReceiptMutationOptions(options));
};

export const getListScInvoicesUrl = (params?: ListScInvoicesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sc-invoices?${stringifiedParams}`
    : `/api/sc-invoices`;
};

export const listScInvoices = async (
  params?: ListScInvoicesParams,
  options?: RequestInit,
): Promise<ScInvoice[]> => {
  return customFetch<ScInvoice[]>(getListScInvoicesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListScInvoicesQueryKey = (params?: ListScInvoicesParams) => {
  return [`/api/sc-invoices`, ...(params ? [params] : [])] as const;
};

export const getListScInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listScInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListScInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScInvoicesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScInvoices>>> = ({
    signal,
  }) => listScInvoices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listScInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListScInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listScInvoices>>
>;
export type ListScInvoicesQueryError = ErrorType<unknown>;

export function useListScInvoices<
  TData = Awaited<ReturnType<typeof listScInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListScInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListScInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateScInvoiceUrl = () => {
  return `/api/sc-invoices`;
};

export const createScInvoice = async (
  createScInvoiceBody: CreateScInvoiceBody,
  options?: RequestInit,
): Promise<ScInvoice> => {
  return customFetch<ScInvoice>(getCreateScInvoiceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createScInvoiceBody),
  });
};

export const getCreateScInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScInvoice>>,
    TError,
    { data: BodyType<CreateScInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createScInvoice>>,
  TError,
  { data: BodyType<CreateScInvoiceBody> },
  TContext
> => {
  const mutationKey = ["createScInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createScInvoice>>,
    { data: BodyType<CreateScInvoiceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createScInvoice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateScInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createScInvoice>>
>;
export type CreateScInvoiceMutationBody = BodyType<CreateScInvoiceBody>;
export type CreateScInvoiceMutationError = ErrorType<unknown>;

export const useCreateScInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScInvoice>>,
    TError,
    { data: BodyType<CreateScInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createScInvoice>>,
  TError,
  { data: BodyType<CreateScInvoiceBody> },
  TContext
> => {
  return useMutation(getCreateScInvoiceMutationOptions(options));
};

export const getUpdateScInvoiceUrl = (id: string) => {
  return `/api/sc-invoices/${id}`;
};

export const updateScInvoice = async (
  id: string,
  updateScInvoiceBody: UpdateScInvoiceBody,
  options?: RequestInit,
): Promise<ScInvoice> => {
  return customFetch<ScInvoice>(getUpdateScInvoiceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateScInvoiceBody),
  });
};

export const getUpdateScInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScInvoice>>,
    TError,
    { id: string; data: BodyType<UpdateScInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateScInvoice>>,
  TError,
  { id: string; data: BodyType<UpdateScInvoiceBody> },
  TContext
> => {
  const mutationKey = ["updateScInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateScInvoice>>,
    { id: string; data: BodyType<UpdateScInvoiceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateScInvoice(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateScInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateScInvoice>>
>;
export type UpdateScInvoiceMutationBody = BodyType<UpdateScInvoiceBody>;
export type UpdateScInvoiceMutationError = ErrorType<unknown>;

export const useUpdateScInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScInvoice>>,
    TError,
    { id: string; data: BodyType<UpdateScInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateScInvoice>>,
  TError,
  { id: string; data: BodyType<UpdateScInvoiceBody> },
  TContext
> => {
  return useMutation(getUpdateScInvoiceMutationOptions(options));
};

export const getDeleteScInvoiceUrl = (id: string) => {
  return `/api/sc-invoices/${id}`;
};

export const deleteScInvoice = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteScInvoiceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteScInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteScInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteScInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteScInvoice>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteScInvoice(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteScInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteScInvoice>>
>;

export type DeleteScInvoiceMutationError = ErrorType<unknown>;

export const useDeleteScInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteScInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteScInvoiceMutationOptions(options));
};

export const getListScPaymentsUrl = (params?: ListScPaymentsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/sc-payments?${stringifiedParams}`
    : `/api/sc-payments`;
};

export const listScPayments = async (
  params?: ListScPaymentsParams,
  options?: RequestInit,
): Promise<ScPayment[]> => {
  return customFetch<ScPayment[]>(getListScPaymentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListScPaymentsQueryKey = (params?: ListScPaymentsParams) => {
  return [`/api/sc-payments`, ...(params ? [params] : [])] as const;
};

export const getListScPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listScPayments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListScPaymentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListScPaymentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listScPayments>>> = ({
    signal,
  }) => listScPayments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listScPayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListScPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listScPayments>>
>;
export type ListScPaymentsQueryError = ErrorType<unknown>;

export function useListScPayments<
  TData = Awaited<ReturnType<typeof listScPayments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListScPaymentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listScPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListScPaymentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateScPaymentUrl = () => {
  return `/api/sc-payments`;
};

export const createScPayment = async (
  createScPaymentBody: CreateScPaymentBody,
  options?: RequestInit,
): Promise<ScPayment> => {
  return customFetch<ScPayment>(getCreateScPaymentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createScPaymentBody),
  });
};

export const getCreateScPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScPayment>>,
    TError,
    { data: BodyType<CreateScPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createScPayment>>,
  TError,
  { data: BodyType<CreateScPaymentBody> },
  TContext
> => {
  const mutationKey = ["createScPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createScPayment>>,
    { data: BodyType<CreateScPaymentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createScPayment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateScPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createScPayment>>
>;
export type CreateScPaymentMutationBody = BodyType<CreateScPaymentBody>;
export type CreateScPaymentMutationError = ErrorType<unknown>;

export const useCreateScPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createScPayment>>,
    TError,
    { data: BodyType<CreateScPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createScPayment>>,
  TError,
  { data: BodyType<CreateScPaymentBody> },
  TContext
> => {
  return useMutation(getCreateScPaymentMutationOptions(options));
};

export const getUpdateScPaymentUrl = (id: string) => {
  return `/api/sc-payments/${id}`;
};

export const updateScPayment = async (
  id: string,
  updateScPaymentBody: UpdateScPaymentBody,
  options?: RequestInit,
): Promise<ScPayment> => {
  return customFetch<ScPayment>(getUpdateScPaymentUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateScPaymentBody),
  });
};

export const getUpdateScPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScPayment>>,
    TError,
    { id: string; data: BodyType<UpdateScPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateScPayment>>,
  TError,
  { id: string; data: BodyType<UpdateScPaymentBody> },
  TContext
> => {
  const mutationKey = ["updateScPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateScPayment>>,
    { id: string; data: BodyType<UpdateScPaymentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateScPayment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateScPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateScPayment>>
>;
export type UpdateScPaymentMutationBody = BodyType<UpdateScPaymentBody>;
export type UpdateScPaymentMutationError = ErrorType<unknown>;

export const useUpdateScPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateScPayment>>,
    TError,
    { id: string; data: BodyType<UpdateScPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateScPayment>>,
  TError,
  { id: string; data: BodyType<UpdateScPaymentBody> },
  TContext
> => {
  return useMutation(getUpdateScPaymentMutationOptions(options));
};

export const getDeleteScPaymentUrl = (id: string) => {
  return `/api/sc-payments/${id}`;
};

export const deleteScPayment = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteScPaymentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteScPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScPayment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteScPayment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteScPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteScPayment>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteScPayment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteScPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteScPayment>>
>;

export type DeleteScPaymentMutationError = ErrorType<unknown>;

export const useDeleteScPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteScPayment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteScPayment>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteScPaymentMutationOptions(options));
};

export const getListSupplierInvoicesUrl = (
  params?: ListSupplierInvoicesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/supplier-invoices?${stringifiedParams}`
    : `/api/supplier-invoices`;
};

export const listSupplierInvoices = async (
  params?: ListSupplierInvoicesParams,
  options?: RequestInit,
): Promise<SupplierInvoice[]> => {
  return customFetch<SupplierInvoice[]>(getListSupplierInvoicesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSupplierInvoicesQueryKey = (
  params?: ListSupplierInvoicesParams,
) => {
  return [`/api/supplier-invoices`, ...(params ? [params] : [])] as const;
};

export const getListSupplierInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSupplierInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSupplierInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSupplierInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSupplierInvoicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSupplierInvoices>>
  > = ({ signal }) =>
    listSupplierInvoices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSupplierInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSupplierInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSupplierInvoices>>
>;
export type ListSupplierInvoicesQueryError = ErrorType<unknown>;

export function useListSupplierInvoices<
  TData = Awaited<ReturnType<typeof listSupplierInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSupplierInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSupplierInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSupplierInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateSupplierInvoiceUrl = () => {
  return `/api/supplier-invoices`;
};

export const createSupplierInvoice = async (
  createSupplierInvoiceBody: CreateSupplierInvoiceBody,
  options?: RequestInit,
): Promise<SupplierInvoice> => {
  return customFetch<SupplierInvoice>(getCreateSupplierInvoiceUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSupplierInvoiceBody),
  });
};

export const getCreateSupplierInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplierInvoice>>,
    TError,
    { data: BodyType<CreateSupplierInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSupplierInvoice>>,
  TError,
  { data: BodyType<CreateSupplierInvoiceBody> },
  TContext
> => {
  const mutationKey = ["createSupplierInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSupplierInvoice>>,
    { data: BodyType<CreateSupplierInvoiceBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSupplierInvoice(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSupplierInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSupplierInvoice>>
>;
export type CreateSupplierInvoiceMutationBody =
  BodyType<CreateSupplierInvoiceBody>;
export type CreateSupplierInvoiceMutationError = ErrorType<unknown>;

export const useCreateSupplierInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplierInvoice>>,
    TError,
    { data: BodyType<CreateSupplierInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSupplierInvoice>>,
  TError,
  { data: BodyType<CreateSupplierInvoiceBody> },
  TContext
> => {
  return useMutation(getCreateSupplierInvoiceMutationOptions(options));
};

export const getUpdateSupplierInvoiceUrl = (id: string) => {
  return `/api/supplier-invoices/${id}`;
};

export const updateSupplierInvoice = async (
  id: string,
  updateSupplierInvoiceBody: UpdateSupplierInvoiceBody,
  options?: RequestInit,
): Promise<SupplierInvoice> => {
  return customFetch<SupplierInvoice>(getUpdateSupplierInvoiceUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSupplierInvoiceBody),
  });
};

export const getUpdateSupplierInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplierInvoice>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSupplierInvoice>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierInvoiceBody> },
  TContext
> => {
  const mutationKey = ["updateSupplierInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSupplierInvoice>>,
    { id: string; data: BodyType<UpdateSupplierInvoiceBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSupplierInvoice(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSupplierInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSupplierInvoice>>
>;
export type UpdateSupplierInvoiceMutationBody =
  BodyType<UpdateSupplierInvoiceBody>;
export type UpdateSupplierInvoiceMutationError = ErrorType<unknown>;

export const useUpdateSupplierInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplierInvoice>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierInvoiceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSupplierInvoice>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierInvoiceBody> },
  TContext
> => {
  return useMutation(getUpdateSupplierInvoiceMutationOptions(options));
};

export const getDeleteSupplierInvoiceUrl = (id: string) => {
  return `/api/supplier-invoices/${id}`;
};

export const deleteSupplierInvoice = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierInvoiceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSupplierInvoiceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplierInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSupplierInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSupplierInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSupplierInvoice>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSupplierInvoice(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSupplierInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSupplierInvoice>>
>;

export type DeleteSupplierInvoiceMutationError = ErrorType<unknown>;

export const useDeleteSupplierInvoice = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplierInvoice>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSupplierInvoice>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSupplierInvoiceMutationOptions(options));
};

export const getListSupplierPaymentsUrl = (
  params?: ListSupplierPaymentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/supplier-payments?${stringifiedParams}`
    : `/api/supplier-payments`;
};

export const listSupplierPayments = async (
  params?: ListSupplierPaymentsParams,
  options?: RequestInit,
): Promise<SupplierPayment[]> => {
  return customFetch<SupplierPayment[]>(getListSupplierPaymentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSupplierPaymentsQueryKey = (
  params?: ListSupplierPaymentsParams,
) => {
  return [`/api/supplier-payments`, ...(params ? [params] : [])] as const;
};

export const getListSupplierPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSupplierPayments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSupplierPaymentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSupplierPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSupplierPaymentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSupplierPayments>>
  > = ({ signal }) =>
    listSupplierPayments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSupplierPayments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSupplierPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSupplierPayments>>
>;
export type ListSupplierPaymentsQueryError = ErrorType<unknown>;

export function useListSupplierPayments<
  TData = Awaited<ReturnType<typeof listSupplierPayments>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSupplierPaymentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSupplierPayments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSupplierPaymentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateSupplierPaymentUrl = () => {
  return `/api/supplier-payments`;
};

export const createSupplierPayment = async (
  createSupplierPaymentBody: CreateSupplierPaymentBody,
  options?: RequestInit,
): Promise<SupplierPayment> => {
  return customFetch<SupplierPayment>(getCreateSupplierPaymentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createSupplierPaymentBody),
  });
};

export const getCreateSupplierPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplierPayment>>,
    TError,
    { data: BodyType<CreateSupplierPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSupplierPayment>>,
  TError,
  { data: BodyType<CreateSupplierPaymentBody> },
  TContext
> => {
  const mutationKey = ["createSupplierPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSupplierPayment>>,
    { data: BodyType<CreateSupplierPaymentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSupplierPayment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSupplierPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSupplierPayment>>
>;
export type CreateSupplierPaymentMutationBody =
  BodyType<CreateSupplierPaymentBody>;
export type CreateSupplierPaymentMutationError = ErrorType<unknown>;

export const useCreateSupplierPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSupplierPayment>>,
    TError,
    { data: BodyType<CreateSupplierPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSupplierPayment>>,
  TError,
  { data: BodyType<CreateSupplierPaymentBody> },
  TContext
> => {
  return useMutation(getCreateSupplierPaymentMutationOptions(options));
};

export const getUpdateSupplierPaymentUrl = (id: string) => {
  return `/api/supplier-payments/${id}`;
};

export const updateSupplierPayment = async (
  id: string,
  updateSupplierPaymentBody: UpdateSupplierPaymentBody,
  options?: RequestInit,
): Promise<SupplierPayment> => {
  return customFetch<SupplierPayment>(getUpdateSupplierPaymentUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSupplierPaymentBody),
  });
};

export const getUpdateSupplierPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplierPayment>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSupplierPayment>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierPaymentBody> },
  TContext
> => {
  const mutationKey = ["updateSupplierPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSupplierPayment>>,
    { id: string; data: BodyType<UpdateSupplierPaymentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSupplierPayment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSupplierPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSupplierPayment>>
>;
export type UpdateSupplierPaymentMutationBody =
  BodyType<UpdateSupplierPaymentBody>;
export type UpdateSupplierPaymentMutationError = ErrorType<unknown>;

export const useUpdateSupplierPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSupplierPayment>>,
    TError,
    { id: string; data: BodyType<UpdateSupplierPaymentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSupplierPayment>>,
  TError,
  { id: string; data: BodyType<UpdateSupplierPaymentBody> },
  TContext
> => {
  return useMutation(getUpdateSupplierPaymentMutationOptions(options));
};

export const getDeleteSupplierPaymentUrl = (id: string) => {
  return `/api/supplier-payments/${id}`;
};

export const deleteSupplierPayment = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierPaymentUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSupplierPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplierPayment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSupplierPayment>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteSupplierPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSupplierPayment>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteSupplierPayment(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSupplierPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSupplierPayment>>
>;

export type DeleteSupplierPaymentMutationError = ErrorType<unknown>;

export const useDeleteSupplierPayment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSupplierPayment>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSupplierPayment>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteSupplierPaymentMutationOptions(options));
};

export const getListPayrollUrl = (params?: ListPayrollParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/payroll?${stringifiedParams}`
    : `/api/payroll`;
};

export const listPayroll = async (
  params?: ListPayrollParams,
  options?: RequestInit,
): Promise<PayrollEntry[]> => {
  return customFetch<PayrollEntry[]>(getListPayrollUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPayrollQueryKey = (params?: ListPayrollParams) => {
  return [`/api/payroll`, ...(params ? [params] : [])] as const;
};

export const getListPayrollQueryOptions = <
  TData = Awaited<ReturnType<typeof listPayroll>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPayrollParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPayroll>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPayrollQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayroll>>> = ({
    signal,
  }) => listPayroll(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPayroll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPayrollQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPayroll>>
>;
export type ListPayrollQueryError = ErrorType<unknown>;

export function useListPayroll<
  TData = Awaited<ReturnType<typeof listPayroll>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPayrollParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPayroll>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPayrollQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreatePayrollEntryUrl = () => {
  return `/api/payroll`;
};

export const createPayrollEntry = async (
  createPayrollEntryBody: CreatePayrollEntryBody,
  options?: RequestInit,
): Promise<PayrollEntry> => {
  return customFetch<PayrollEntry>(getCreatePayrollEntryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPayrollEntryBody),
  });
};

export const getCreatePayrollEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayrollEntry>>,
    TError,
    { data: BodyType<CreatePayrollEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPayrollEntry>>,
  TError,
  { data: BodyType<CreatePayrollEntryBody> },
  TContext
> => {
  const mutationKey = ["createPayrollEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPayrollEntry>>,
    { data: BodyType<CreatePayrollEntryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPayrollEntry(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePayrollEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPayrollEntry>>
>;
export type CreatePayrollEntryMutationBody = BodyType<CreatePayrollEntryBody>;
export type CreatePayrollEntryMutationError = ErrorType<unknown>;

export const useCreatePayrollEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPayrollEntry>>,
    TError,
    { data: BodyType<CreatePayrollEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPayrollEntry>>,
  TError,
  { data: BodyType<CreatePayrollEntryBody> },
  TContext
> => {
  return useMutation(getCreatePayrollEntryMutationOptions(options));
};

export const getUpdatePayrollEntryUrl = (id: string) => {
  return `/api/payroll/${id}`;
};

export const updatePayrollEntry = async (
  id: string,
  updatePayrollEntryBody: UpdatePayrollEntryBody,
  options?: RequestInit,
): Promise<PayrollEntry> => {
  return customFetch<PayrollEntry>(getUpdatePayrollEntryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePayrollEntryBody),
  });
};

export const getUpdatePayrollEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePayrollEntry>>,
    TError,
    { id: string; data: BodyType<UpdatePayrollEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePayrollEntry>>,
  TError,
  { id: string; data: BodyType<UpdatePayrollEntryBody> },
  TContext
> => {
  const mutationKey = ["updatePayrollEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePayrollEntry>>,
    { id: string; data: BodyType<UpdatePayrollEntryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePayrollEntry(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePayrollEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePayrollEntry>>
>;
export type UpdatePayrollEntryMutationBody = BodyType<UpdatePayrollEntryBody>;
export type UpdatePayrollEntryMutationError = ErrorType<unknown>;

export const useUpdatePayrollEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePayrollEntry>>,
    TError,
    { id: string; data: BodyType<UpdatePayrollEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePayrollEntry>>,
  TError,
  { id: string; data: BodyType<UpdatePayrollEntryBody> },
  TContext
> => {
  return useMutation(getUpdatePayrollEntryMutationOptions(options));
};

export const getDeletePayrollEntryUrl = (id: string) => {
  return `/api/payroll/${id}`;
};

export const deletePayrollEntry = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePayrollEntryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePayrollEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePayrollEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePayrollEntry>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deletePayrollEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePayrollEntry>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deletePayrollEntry(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePayrollEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePayrollEntry>>
>;

export type DeletePayrollEntryMutationError = ErrorType<unknown>;

export const useDeletePayrollEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePayrollEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePayrollEntry>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeletePayrollEntryMutationOptions(options));
};

export const getListBudgetUrl = (params?: ListBudgetParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/budget?${stringifiedParams}`
    : `/api/budget`;
};

export const listBudget = async (
  params?: ListBudgetParams,
  options?: RequestInit,
): Promise<BudgetLine[]> => {
  return customFetch<BudgetLine[]>(getListBudgetUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListBudgetQueryKey = (params?: ListBudgetParams) => {
  return [`/api/budget`, ...(params ? [params] : [])] as const;
};

export const getListBudgetQueryOptions = <
  TData = Awaited<ReturnType<typeof listBudget>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBudgetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBudget>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBudgetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBudget>>> = ({
    signal,
  }) => listBudget(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBudget>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBudgetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBudget>>
>;
export type ListBudgetQueryError = ErrorType<unknown>;

export function useListBudget<
  TData = Awaited<ReturnType<typeof listBudget>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBudgetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listBudget>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBudgetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateBudgetLineUrl = () => {
  return `/api/budget`;
};

export const createBudgetLine = async (
  createBudgetLineBody: CreateBudgetLineBody,
  options?: RequestInit,
): Promise<BudgetLine> => {
  return customFetch<BudgetLine>(getCreateBudgetLineUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBudgetLineBody),
  });
};

export const getCreateBudgetLineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBudgetLine>>,
    TError,
    { data: BodyType<CreateBudgetLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBudgetLine>>,
  TError,
  { data: BodyType<CreateBudgetLineBody> },
  TContext
> => {
  const mutationKey = ["createBudgetLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBudgetLine>>,
    { data: BodyType<CreateBudgetLineBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBudgetLine(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBudgetLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBudgetLine>>
>;
export type CreateBudgetLineMutationBody = BodyType<CreateBudgetLineBody>;
export type CreateBudgetLineMutationError = ErrorType<unknown>;

export const useCreateBudgetLine = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBudgetLine>>,
    TError,
    { data: BodyType<CreateBudgetLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBudgetLine>>,
  TError,
  { data: BodyType<CreateBudgetLineBody> },
  TContext
> => {
  return useMutation(getCreateBudgetLineMutationOptions(options));
};

export const getUpdateBudgetLineUrl = (id: string) => {
  return `/api/budget/${id}`;
};

export const updateBudgetLine = async (
  id: string,
  updateBudgetLineBody: UpdateBudgetLineBody,
  options?: RequestInit,
): Promise<BudgetLine> => {
  return customFetch<BudgetLine>(getUpdateBudgetLineUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBudgetLineBody),
  });
};

export const getUpdateBudgetLineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBudgetLine>>,
    TError,
    { id: string; data: BodyType<UpdateBudgetLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBudgetLine>>,
  TError,
  { id: string; data: BodyType<UpdateBudgetLineBody> },
  TContext
> => {
  const mutationKey = ["updateBudgetLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBudgetLine>>,
    { id: string; data: BodyType<UpdateBudgetLineBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBudgetLine(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBudgetLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBudgetLine>>
>;
export type UpdateBudgetLineMutationBody = BodyType<UpdateBudgetLineBody>;
export type UpdateBudgetLineMutationError = ErrorType<unknown>;

export const useUpdateBudgetLine = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBudgetLine>>,
    TError,
    { id: string; data: BodyType<UpdateBudgetLineBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBudgetLine>>,
  TError,
  { id: string; data: BodyType<UpdateBudgetLineBody> },
  TContext
> => {
  return useMutation(getUpdateBudgetLineMutationOptions(options));
};

export const getDeleteBudgetLineUrl = (id: string) => {
  return `/api/budget/${id}`;
};

export const deleteBudgetLine = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteBudgetLineUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBudgetLineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBudgetLine>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBudgetLine>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteBudgetLine"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBudgetLine>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBudgetLine(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBudgetLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBudgetLine>>
>;

export type DeleteBudgetLineMutationError = ErrorType<unknown>;

export const useDeleteBudgetLine = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBudgetLine>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBudgetLine>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteBudgetLineMutationOptions(options));
};

export const getListBoqUrl = (params?: ListBoqParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/boq?${stringifiedParams}`
    : `/api/boq`;
};

export const listBoq = async (
  params?: ListBoqParams,
  options?: RequestInit,
): Promise<BoqItem[]> => {
  return customFetch<BoqItem[]>(getListBoqUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListBoqQueryKey = (params?: ListBoqParams) => {
  return [`/api/boq`, ...(params ? [params] : [])] as const;
};

export const getListBoqQueryOptions = <
  TData = Awaited<ReturnType<typeof listBoq>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBoqParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listBoq>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListBoqQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listBoq>>> = ({
    signal,
  }) => listBoq(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBoq>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListBoqQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBoq>>
>;
export type ListBoqQueryError = ErrorType<unknown>;

export function useListBoq<
  TData = Awaited<ReturnType<typeof listBoq>>,
  TError = ErrorType<unknown>,
>(
  params?: ListBoqParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof listBoq>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListBoqQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateBoqItemUrl = () => {
  return `/api/boq`;
};

export const createBoqItem = async (
  createBoqItemBody: CreateBoqItemBody,
  options?: RequestInit,
): Promise<BoqItem> => {
  return customFetch<BoqItem>(getCreateBoqItemUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createBoqItemBody),
  });
};

export const getCreateBoqItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBoqItem>>,
    TError,
    { data: BodyType<CreateBoqItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBoqItem>>,
  TError,
  { data: BodyType<CreateBoqItemBody> },
  TContext
> => {
  const mutationKey = ["createBoqItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBoqItem>>,
    { data: BodyType<CreateBoqItemBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createBoqItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBoqItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBoqItem>>
>;
export type CreateBoqItemMutationBody = BodyType<CreateBoqItemBody>;
export type CreateBoqItemMutationError = ErrorType<unknown>;

export const useCreateBoqItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBoqItem>>,
    TError,
    { data: BodyType<CreateBoqItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBoqItem>>,
  TError,
  { data: BodyType<CreateBoqItemBody> },
  TContext
> => {
  return useMutation(getCreateBoqItemMutationOptions(options));
};

export const getUpdateBoqItemUrl = (id: string) => {
  return `/api/boq/${id}`;
};

export const updateBoqItem = async (
  id: string,
  updateBoqItemBody: UpdateBoqItemBody,
  options?: RequestInit,
): Promise<BoqItem> => {
  return customFetch<BoqItem>(getUpdateBoqItemUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateBoqItemBody),
  });
};

export const getUpdateBoqItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBoqItem>>,
    TError,
    { id: string; data: BodyType<UpdateBoqItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBoqItem>>,
  TError,
  { id: string; data: BodyType<UpdateBoqItemBody> },
  TContext
> => {
  const mutationKey = ["updateBoqItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBoqItem>>,
    { id: string; data: BodyType<UpdateBoqItemBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBoqItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBoqItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBoqItem>>
>;
export type UpdateBoqItemMutationBody = BodyType<UpdateBoqItemBody>;
export type UpdateBoqItemMutationError = ErrorType<unknown>;

export const useUpdateBoqItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBoqItem>>,
    TError,
    { id: string; data: BodyType<UpdateBoqItemBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBoqItem>>,
  TError,
  { id: string; data: BodyType<UpdateBoqItemBody> },
  TContext
> => {
  return useMutation(getUpdateBoqItemMutationOptions(options));
};

export const getDeleteBoqItemUrl = (id: string) => {
  return `/api/boq/${id}`;
};

export const deleteBoqItem = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteBoqItemUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBoqItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBoqItem>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBoqItem>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteBoqItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBoqItem>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteBoqItem(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBoqItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBoqItem>>
>;

export type DeleteBoqItemMutationError = ErrorType<unknown>;

export const useDeleteBoqItem = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBoqItem>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBoqItem>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteBoqItemMutationOptions(options));
};

export const getListPromissoryNotesUrl = (
  params?: ListPromissoryNotesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/promissory-notes?${stringifiedParams}`
    : `/api/promissory-notes`;
};

export const listPromissoryNotes = async (
  params?: ListPromissoryNotesParams,
  options?: RequestInit,
): Promise<PromissoryNote[]> => {
  return customFetch<PromissoryNote[]>(getListPromissoryNotesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListPromissoryNotesQueryKey = (
  params?: ListPromissoryNotesParams,
) => {
  return [`/api/promissory-notes`, ...(params ? [params] : [])] as const;
};

export const getListPromissoryNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listPromissoryNotes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPromissoryNotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPromissoryNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPromissoryNotesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPromissoryNotes>>
  > = ({ signal }) =>
    listPromissoryNotes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPromissoryNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPromissoryNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPromissoryNotes>>
>;
export type ListPromissoryNotesQueryError = ErrorType<unknown>;

export function useListPromissoryNotes<
  TData = Awaited<ReturnType<typeof listPromissoryNotes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListPromissoryNotesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listPromissoryNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPromissoryNotesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreatePromissoryNoteUrl = () => {
  return `/api/promissory-notes`;
};

export const createPromissoryNote = async (
  createPromissoryNoteBody: CreatePromissoryNoteBody,
  options?: RequestInit,
): Promise<PromissoryNote> => {
  return customFetch<PromissoryNote>(getCreatePromissoryNoteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createPromissoryNoteBody),
  });
};

export const getCreatePromissoryNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPromissoryNote>>,
    TError,
    { data: BodyType<CreatePromissoryNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPromissoryNote>>,
  TError,
  { data: BodyType<CreatePromissoryNoteBody> },
  TContext
> => {
  const mutationKey = ["createPromissoryNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPromissoryNote>>,
    { data: BodyType<CreatePromissoryNoteBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createPromissoryNote(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePromissoryNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPromissoryNote>>
>;
export type CreatePromissoryNoteMutationBody =
  BodyType<CreatePromissoryNoteBody>;
export type CreatePromissoryNoteMutationError = ErrorType<unknown>;

export const useCreatePromissoryNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPromissoryNote>>,
    TError,
    { data: BodyType<CreatePromissoryNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPromissoryNote>>,
  TError,
  { data: BodyType<CreatePromissoryNoteBody> },
  TContext
> => {
  return useMutation(getCreatePromissoryNoteMutationOptions(options));
};

export const getUpdatePromissoryNoteUrl = (id: string) => {
  return `/api/promissory-notes/${id}`;
};

export const updatePromissoryNote = async (
  id: string,
  updatePromissoryNoteBody: UpdatePromissoryNoteBody,
  options?: RequestInit,
): Promise<PromissoryNote> => {
  return customFetch<PromissoryNote>(getUpdatePromissoryNoteUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updatePromissoryNoteBody),
  });
};

export const getUpdatePromissoryNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePromissoryNote>>,
    TError,
    { id: string; data: BodyType<UpdatePromissoryNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePromissoryNote>>,
  TError,
  { id: string; data: BodyType<UpdatePromissoryNoteBody> },
  TContext
> => {
  const mutationKey = ["updatePromissoryNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePromissoryNote>>,
    { id: string; data: BodyType<UpdatePromissoryNoteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePromissoryNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePromissoryNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePromissoryNote>>
>;
export type UpdatePromissoryNoteMutationBody =
  BodyType<UpdatePromissoryNoteBody>;
export type UpdatePromissoryNoteMutationError = ErrorType<unknown>;

export const useUpdatePromissoryNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePromissoryNote>>,
    TError,
    { id: string; data: BodyType<UpdatePromissoryNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePromissoryNote>>,
  TError,
  { id: string; data: BodyType<UpdatePromissoryNoteBody> },
  TContext
> => {
  return useMutation(getUpdatePromissoryNoteMutationOptions(options));
};

export const getDeletePromissoryNoteUrl = (id: string) => {
  return `/api/promissory-notes/${id}`;
};

export const deletePromissoryNote = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePromissoryNoteUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePromissoryNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePromissoryNote>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePromissoryNote>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deletePromissoryNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePromissoryNote>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deletePromissoryNote(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePromissoryNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePromissoryNote>>
>;

export type DeletePromissoryNoteMutationError = ErrorType<unknown>;

export const useDeletePromissoryNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePromissoryNote>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePromissoryNote>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeletePromissoryNoteMutationOptions(options));
};

export const getListCashFlowUrl = (params?: ListCashFlowParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/cash-flow?${stringifiedParams}`
    : `/api/cash-flow`;
};

export const listCashFlow = async (
  params?: ListCashFlowParams,
  options?: RequestInit,
): Promise<CashFlowEntry[]> => {
  return customFetch<CashFlowEntry[]>(getListCashFlowUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCashFlowQueryKey = (params?: ListCashFlowParams) => {
  return [`/api/cash-flow`, ...(params ? [params] : [])] as const;
};

export const getListCashFlowQueryOptions = <
  TData = Awaited<ReturnType<typeof listCashFlow>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCashFlowParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCashFlow>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCashFlowQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCashFlow>>> = ({
    signal,
  }) => listCashFlow(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCashFlow>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCashFlowQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCashFlow>>
>;
export type ListCashFlowQueryError = ErrorType<unknown>;

export function useListCashFlow<
  TData = Awaited<ReturnType<typeof listCashFlow>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCashFlowParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCashFlow>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCashFlowQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateCashFlowEntryUrl = () => {
  return `/api/cash-flow`;
};

export const createCashFlowEntry = async (
  createCashFlowEntryBody: CreateCashFlowEntryBody,
  options?: RequestInit,
): Promise<CashFlowEntry> => {
  return customFetch<CashFlowEntry>(getCreateCashFlowEntryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCashFlowEntryBody),
  });
};

export const getCreateCashFlowEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCashFlowEntry>>,
    TError,
    { data: BodyType<CreateCashFlowEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCashFlowEntry>>,
  TError,
  { data: BodyType<CreateCashFlowEntryBody> },
  TContext
> => {
  const mutationKey = ["createCashFlowEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCashFlowEntry>>,
    { data: BodyType<CreateCashFlowEntryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCashFlowEntry(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCashFlowEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCashFlowEntry>>
>;
export type CreateCashFlowEntryMutationBody = BodyType<CreateCashFlowEntryBody>;
export type CreateCashFlowEntryMutationError = ErrorType<unknown>;

export const useCreateCashFlowEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCashFlowEntry>>,
    TError,
    { data: BodyType<CreateCashFlowEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCashFlowEntry>>,
  TError,
  { data: BodyType<CreateCashFlowEntryBody> },
  TContext
> => {
  return useMutation(getCreateCashFlowEntryMutationOptions(options));
};

export const getUpdateCashFlowEntryUrl = (id: string) => {
  return `/api/cash-flow/${id}`;
};

export const updateCashFlowEntry = async (
  id: string,
  updateCashFlowEntryBody: UpdateCashFlowEntryBody,
  options?: RequestInit,
): Promise<CashFlowEntry> => {
  return customFetch<CashFlowEntry>(getUpdateCashFlowEntryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCashFlowEntryBody),
  });
};

export const getUpdateCashFlowEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCashFlowEntry>>,
    TError,
    { id: string; data: BodyType<UpdateCashFlowEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCashFlowEntry>>,
  TError,
  { id: string; data: BodyType<UpdateCashFlowEntryBody> },
  TContext
> => {
  const mutationKey = ["updateCashFlowEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCashFlowEntry>>,
    { id: string; data: BodyType<UpdateCashFlowEntryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCashFlowEntry(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCashFlowEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCashFlowEntry>>
>;
export type UpdateCashFlowEntryMutationBody = BodyType<UpdateCashFlowEntryBody>;
export type UpdateCashFlowEntryMutationError = ErrorType<unknown>;

export const useUpdateCashFlowEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCashFlowEntry>>,
    TError,
    { id: string; data: BodyType<UpdateCashFlowEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCashFlowEntry>>,
  TError,
  { id: string; data: BodyType<UpdateCashFlowEntryBody> },
  TContext
> => {
  return useMutation(getUpdateCashFlowEntryMutationOptions(options));
};

export const getDeleteCashFlowEntryUrl = (id: string) => {
  return `/api/cash-flow/${id}`;
};

export const deleteCashFlowEntry = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCashFlowEntryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCashFlowEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCashFlowEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCashFlowEntry>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteCashFlowEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCashFlowEntry>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCashFlowEntry(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCashFlowEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCashFlowEntry>>
>;

export type DeleteCashFlowEntryMutationError = ErrorType<unknown>;

export const useDeleteCashFlowEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCashFlowEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCashFlowEntry>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteCashFlowEntryMutationOptions(options));
};

export const getListCustomersUrl = (params?: ListCustomersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/customers?${stringifiedParams}`
    : `/api/customers`;
};

export const listCustomers = async (
  params?: ListCustomersParams,
  options?: RequestInit,
): Promise<Customer[]> => {
  return customFetch<Customer[]>(getListCustomersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCustomersQueryKey = (params?: ListCustomersParams) => {
  return [`/api/customers`, ...(params ? [params] : [])] as const;
};

export const getListCustomersQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCustomersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomers>>> = ({
    signal,
  }) => listCustomers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomers>>
>;
export type ListCustomersQueryError = ErrorType<unknown>;

export function useListCustomers<
  TData = Awaited<ReturnType<typeof listCustomers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateCustomerUrl = () => {
  return `/api/customers`;
};

export const createCustomer = async (
  createCustomerBody: CreateCustomerBody,
  options?: RequestInit,
): Promise<Customer> => {
  return customFetch<Customer>(getCreateCustomerUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCustomerBody),
  });
};

export const getCreateCustomerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomer>>,
    TError,
    { data: BodyType<CreateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomer>>,
  TError,
  { data: BodyType<CreateCustomerBody> },
  TContext
> => {
  const mutationKey = ["createCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomer>>,
    { data: BodyType<CreateCustomerBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCustomer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomer>>
>;
export type CreateCustomerMutationBody = BodyType<CreateCustomerBody>;
export type CreateCustomerMutationError = ErrorType<unknown>;

export const useCreateCustomer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomer>>,
    TError,
    { data: BodyType<CreateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCustomer>>,
  TError,
  { data: BodyType<CreateCustomerBody> },
  TContext
> => {
  return useMutation(getCreateCustomerMutationOptions(options));
};

export const getUpdateCustomerUrl = (id: string) => {
  return `/api/customers/${id}`;
};

export const updateCustomer = async (
  id: string,
  updateCustomerBody: UpdateCustomerBody,
  options?: RequestInit,
): Promise<Customer> => {
  return customFetch<Customer>(getUpdateCustomerUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCustomerBody),
  });
};

export const getUpdateCustomerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomer>>,
    TError,
    { id: string; data: BodyType<UpdateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCustomer>>,
  TError,
  { id: string; data: BodyType<UpdateCustomerBody> },
  TContext
> => {
  const mutationKey = ["updateCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCustomer>>,
    { id: string; data: BodyType<UpdateCustomerBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCustomer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCustomer>>
>;
export type UpdateCustomerMutationBody = BodyType<UpdateCustomerBody>;
export type UpdateCustomerMutationError = ErrorType<unknown>;

export const useUpdateCustomer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCustomer>>,
    TError,
    { id: string; data: BodyType<UpdateCustomerBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCustomer>>,
  TError,
  { id: string; data: BodyType<UpdateCustomerBody> },
  TContext
> => {
  return useMutation(getUpdateCustomerMutationOptions(options));
};

export const getDeleteCustomerUrl = (id: string) => {
  return `/api/customers/${id}`;
};

export const deleteCustomer = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteCustomerUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCustomerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCustomer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCustomer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCustomer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCustomer>>
>;

export type DeleteCustomerMutationError = ErrorType<unknown>;

export const useDeleteCustomer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCustomer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCustomer>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteCustomerMutationOptions(options));
};

export const getListMasterSCsUrl = (params?: ListMasterSCsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/master-scs?${stringifiedParams}`
    : `/api/master-scs`;
};

export const listMasterSCs = async (
  params?: ListMasterSCsParams,
  options?: RequestInit,
): Promise<MasterSC[]> => {
  return customFetch<MasterSC[]>(getListMasterSCsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMasterSCsQueryKey = (params?: ListMasterSCsParams) => {
  return [`/api/master-scs`, ...(params ? [params] : [])] as const;
};

export const getListMasterSCsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMasterSCs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMasterSCsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMasterSCs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMasterSCsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMasterSCs>>> = ({
    signal,
  }) => listMasterSCs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMasterSCs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMasterSCsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMasterSCs>>
>;
export type ListMasterSCsQueryError = ErrorType<unknown>;

export function useListMasterSCs<
  TData = Awaited<ReturnType<typeof listMasterSCs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMasterSCsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMasterSCs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMasterSCsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateMasterSCUrl = () => {
  return `/api/master-scs`;
};

export const createMasterSC = async (
  createMasterSCBody: CreateMasterSCBody,
  options?: RequestInit,
): Promise<MasterSC> => {
  return customFetch<MasterSC>(getCreateMasterSCUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMasterSCBody),
  });
};

export const getCreateMasterSCMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMasterSC>>,
    TError,
    { data: BodyType<CreateMasterSCBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMasterSC>>,
  TError,
  { data: BodyType<CreateMasterSCBody> },
  TContext
> => {
  const mutationKey = ["createMasterSC"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMasterSC>>,
    { data: BodyType<CreateMasterSCBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMasterSC(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMasterSCMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMasterSC>>
>;
export type CreateMasterSCMutationBody = BodyType<CreateMasterSCBody>;
export type CreateMasterSCMutationError = ErrorType<unknown>;

export const useCreateMasterSC = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMasterSC>>,
    TError,
    { data: BodyType<CreateMasterSCBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMasterSC>>,
  TError,
  { data: BodyType<CreateMasterSCBody> },
  TContext
> => {
  return useMutation(getCreateMasterSCMutationOptions(options));
};

export const getUpdateMasterSCUrl = (id: string) => {
  return `/api/master-scs/${id}`;
};

export const updateMasterSC = async (
  id: string,
  updateMasterSCBody: UpdateMasterSCBody,
  options?: RequestInit,
): Promise<MasterSC> => {
  return customFetch<MasterSC>(getUpdateMasterSCUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMasterSCBody),
  });
};

export const getUpdateMasterSCMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMasterSC>>,
    TError,
    { id: string; data: BodyType<UpdateMasterSCBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMasterSC>>,
  TError,
  { id: string; data: BodyType<UpdateMasterSCBody> },
  TContext
> => {
  const mutationKey = ["updateMasterSC"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMasterSC>>,
    { id: string; data: BodyType<UpdateMasterSCBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMasterSC(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMasterSCMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMasterSC>>
>;
export type UpdateMasterSCMutationBody = BodyType<UpdateMasterSCBody>;
export type UpdateMasterSCMutationError = ErrorType<unknown>;

export const useUpdateMasterSC = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMasterSC>>,
    TError,
    { id: string; data: BodyType<UpdateMasterSCBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMasterSC>>,
  TError,
  { id: string; data: BodyType<UpdateMasterSCBody> },
  TContext
> => {
  return useMutation(getUpdateMasterSCMutationOptions(options));
};

export const getDeleteMasterSCUrl = (id: string) => {
  return `/api/master-scs/${id}`;
};

export const deleteMasterSC = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMasterSCUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMasterSCMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMasterSC>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMasterSC>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteMasterSC"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMasterSC>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMasterSC(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMasterSCMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMasterSC>>
>;

export type DeleteMasterSCMutationError = ErrorType<unknown>;

export const useDeleteMasterSC = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMasterSC>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMasterSC>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteMasterSCMutationOptions(options));
};

export const getListExpenseCategoriesUrl = (
  params?: ListExpenseCategoriesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/expense-categories?${stringifiedParams}`
    : `/api/expense-categories`;
};

export const listExpenseCategories = async (
  params?: ListExpenseCategoriesParams,
  options?: RequestInit,
): Promise<ExpenseCategory[]> => {
  return customFetch<ExpenseCategory[]>(getListExpenseCategoriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListExpenseCategoriesQueryKey = (
  params?: ListExpenseCategoriesParams,
) => {
  return [`/api/expense-categories`, ...(params ? [params] : [])] as const;
};

export const getListExpenseCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listExpenseCategories>>,
  TError = ErrorType<unknown>,
>(
  params?: ListExpenseCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExpenseCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListExpenseCategoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listExpenseCategories>>
  > = ({ signal }) =>
    listExpenseCategories(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listExpenseCategories>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListExpenseCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listExpenseCategories>>
>;
export type ListExpenseCategoriesQueryError = ErrorType<unknown>;

export function useListExpenseCategories<
  TData = Awaited<ReturnType<typeof listExpenseCategories>>,
  TError = ErrorType<unknown>,
>(
  params?: ListExpenseCategoriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listExpenseCategories>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListExpenseCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateExpenseCategoryUrl = () => {
  return `/api/expense-categories`;
};

export const createExpenseCategory = async (
  createExpenseCategoryBody: CreateExpenseCategoryBody,
  options?: RequestInit,
): Promise<ExpenseCategory> => {
  return customFetch<ExpenseCategory>(getCreateExpenseCategoryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createExpenseCategoryBody),
  });
};

export const getCreateExpenseCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExpenseCategory>>,
    TError,
    { data: BodyType<CreateExpenseCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createExpenseCategory>>,
  TError,
  { data: BodyType<CreateExpenseCategoryBody> },
  TContext
> => {
  const mutationKey = ["createExpenseCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createExpenseCategory>>,
    { data: BodyType<CreateExpenseCategoryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createExpenseCategory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateExpenseCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createExpenseCategory>>
>;
export type CreateExpenseCategoryMutationBody =
  BodyType<CreateExpenseCategoryBody>;
export type CreateExpenseCategoryMutationError = ErrorType<unknown>;

export const useCreateExpenseCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createExpenseCategory>>,
    TError,
    { data: BodyType<CreateExpenseCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createExpenseCategory>>,
  TError,
  { data: BodyType<CreateExpenseCategoryBody> },
  TContext
> => {
  return useMutation(getCreateExpenseCategoryMutationOptions(options));
};

export const getUpdateExpenseCategoryUrl = (id: string) => {
  return `/api/expense-categories/${id}`;
};

export const updateExpenseCategory = async (
  id: string,
  updateExpenseCategoryBody: UpdateExpenseCategoryBody,
  options?: RequestInit,
): Promise<ExpenseCategory> => {
  return customFetch<ExpenseCategory>(getUpdateExpenseCategoryUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateExpenseCategoryBody),
  });
};

export const getUpdateExpenseCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpenseCategory>>,
    TError,
    { id: string; data: BodyType<UpdateExpenseCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateExpenseCategory>>,
  TError,
  { id: string; data: BodyType<UpdateExpenseCategoryBody> },
  TContext
> => {
  const mutationKey = ["updateExpenseCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateExpenseCategory>>,
    { id: string; data: BodyType<UpdateExpenseCategoryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateExpenseCategory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateExpenseCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateExpenseCategory>>
>;
export type UpdateExpenseCategoryMutationBody =
  BodyType<UpdateExpenseCategoryBody>;
export type UpdateExpenseCategoryMutationError = ErrorType<unknown>;

export const useUpdateExpenseCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateExpenseCategory>>,
    TError,
    { id: string; data: BodyType<UpdateExpenseCategoryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateExpenseCategory>>,
  TError,
  { id: string; data: BodyType<UpdateExpenseCategoryBody> },
  TContext
> => {
  return useMutation(getUpdateExpenseCategoryMutationOptions(options));
};

export const getDeleteExpenseCategoryUrl = (id: string) => {
  return `/api/expense-categories/${id}`;
};

export const deleteExpenseCategory = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteExpenseCategoryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteExpenseCategoryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExpenseCategory>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteExpenseCategory>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteExpenseCategory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteExpenseCategory>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteExpenseCategory(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteExpenseCategoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteExpenseCategory>>
>;

export type DeleteExpenseCategoryMutationError = ErrorType<unknown>;

export const useDeleteExpenseCategory = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteExpenseCategory>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteExpenseCategory>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteExpenseCategoryMutationOptions(options));
};

export const getListTaxTypesUrl = (params?: ListTaxTypesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tax-types?${stringifiedParams}`
    : `/api/tax-types`;
};

export const listTaxTypes = async (
  params?: ListTaxTypesParams,
  options?: RequestInit,
): Promise<TaxTypeWithRates[]> => {
  return customFetch<TaxTypeWithRates[]>(getListTaxTypesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTaxTypesQueryKey = (params?: ListTaxTypesParams) => {
  return [`/api/tax-types`, ...(params ? [params] : [])] as const;
};

export const getListTaxTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listTaxTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTaxTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTaxTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTaxTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTaxTypes>>> = ({
    signal,
  }) => listTaxTypes(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTaxTypes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTaxTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTaxTypes>>
>;
export type ListTaxTypesQueryError = ErrorType<unknown>;

export function useListTaxTypes<
  TData = Awaited<ReturnType<typeof listTaxTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTaxTypesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTaxTypes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTaxTypesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateTaxTypeUrl = () => {
  return `/api/tax-types`;
};

export const createTaxType = async (
  createTaxTypeBody: CreateTaxTypeBody,
  options?: RequestInit,
): Promise<TaxTypeWithRates> => {
  return customFetch<TaxTypeWithRates>(getCreateTaxTypeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaxTypeBody),
  });
};

export const getCreateTaxTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaxType>>,
    TError,
    { data: BodyType<CreateTaxTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaxType>>,
  TError,
  { data: BodyType<CreateTaxTypeBody> },
  TContext
> => {
  const mutationKey = ["createTaxType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaxType>>,
    { data: BodyType<CreateTaxTypeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTaxType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaxTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTaxType>>
>;
export type CreateTaxTypeMutationBody = BodyType<CreateTaxTypeBody>;
export type CreateTaxTypeMutationError = ErrorType<unknown>;

export const useCreateTaxType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaxType>>,
    TError,
    { data: BodyType<CreateTaxTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTaxType>>,
  TError,
  { data: BodyType<CreateTaxTypeBody> },
  TContext
> => {
  return useMutation(getCreateTaxTypeMutationOptions(options));
};

export const getUpdateTaxTypeUrl = (id: string) => {
  return `/api/tax-types/${id}`;
};

export const updateTaxType = async (
  id: string,
  updateTaxTypeBody: UpdateTaxTypeBody,
  options?: RequestInit,
): Promise<TaxType> => {
  return customFetch<TaxType>(getUpdateTaxTypeUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaxTypeBody),
  });
};

export const getUpdateTaxTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaxType>>,
    TError,
    { id: string; data: BodyType<UpdateTaxTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTaxType>>,
  TError,
  { id: string; data: BodyType<UpdateTaxTypeBody> },
  TContext
> => {
  const mutationKey = ["updateTaxType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaxType>>,
    { id: string; data: BodyType<UpdateTaxTypeBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTaxType(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaxTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTaxType>>
>;
export type UpdateTaxTypeMutationBody = BodyType<UpdateTaxTypeBody>;
export type UpdateTaxTypeMutationError = ErrorType<unknown>;

export const useUpdateTaxType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaxType>>,
    TError,
    { id: string; data: BodyType<UpdateTaxTypeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTaxType>>,
  TError,
  { id: string; data: BodyType<UpdateTaxTypeBody> },
  TContext
> => {
  return useMutation(getUpdateTaxTypeMutationOptions(options));
};

export const getDeleteTaxTypeUrl = (id: string) => {
  return `/api/tax-types/${id}`;
};

export const deleteTaxType = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTaxTypeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaxTypeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaxType>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTaxType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaxType>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTaxType(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaxTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTaxType>>
>;

export type DeleteTaxTypeMutationError = ErrorType<unknown>;

export const useDeleteTaxType = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxType>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaxType>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTaxTypeMutationOptions(options));
};

export const getCreateTaxRateUrl = () => {
  return `/api/tax-rates`;
};

export const createTaxRate = async (
  createTaxRateBody: CreateTaxRateBody,
  options?: RequestInit,
): Promise<TaxRate> => {
  return customFetch<TaxRate>(getCreateTaxRateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaxRateBody),
  });
};

export const getCreateTaxRateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaxRate>>,
    TError,
    { data: BodyType<CreateTaxRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTaxRate>>,
  TError,
  { data: BodyType<CreateTaxRateBody> },
  TContext
> => {
  const mutationKey = ["createTaxRate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaxRate>>,
    { data: BodyType<CreateTaxRateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTaxRate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaxRateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTaxRate>>
>;
export type CreateTaxRateMutationBody = BodyType<CreateTaxRateBody>;
export type CreateTaxRateMutationError = ErrorType<unknown>;

export const useCreateTaxRate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTaxRate>>,
    TError,
    { data: BodyType<CreateTaxRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTaxRate>>,
  TError,
  { data: BodyType<CreateTaxRateBody> },
  TContext
> => {
  return useMutation(getCreateTaxRateMutationOptions(options));
};

export const getUpdateTaxRateUrl = (id: string) => {
  return `/api/tax-rates/${id}`;
};

export const updateTaxRate = async (
  id: string,
  updateTaxRateBody: UpdateTaxRateBody,
  options?: RequestInit,
): Promise<TaxRate> => {
  return customFetch<TaxRate>(getUpdateTaxRateUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaxRateBody),
  });
};

export const getUpdateTaxRateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaxRate>>,
    TError,
    { id: string; data: BodyType<UpdateTaxRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTaxRate>>,
  TError,
  { id: string; data: BodyType<UpdateTaxRateBody> },
  TContext
> => {
  const mutationKey = ["updateTaxRate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaxRate>>,
    { id: string; data: BodyType<UpdateTaxRateBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTaxRate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaxRateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTaxRate>>
>;
export type UpdateTaxRateMutationBody = BodyType<UpdateTaxRateBody>;
export type UpdateTaxRateMutationError = ErrorType<unknown>;

export const useUpdateTaxRate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaxRate>>,
    TError,
    { id: string; data: BodyType<UpdateTaxRateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTaxRate>>,
  TError,
  { id: string; data: BodyType<UpdateTaxRateBody> },
  TContext
> => {
  return useMutation(getUpdateTaxRateMutationOptions(options));
};

export const getDeleteTaxRateUrl = (id: string) => {
  return `/api/tax-rates/${id}`;
};

export const deleteTaxRate = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteTaxRateUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTaxRateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxRate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTaxRate>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteTaxRate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaxRate>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteTaxRate(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTaxRateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTaxRate>>
>;

export type DeleteTaxRateMutationError = ErrorType<unknown>;

export const useDeleteTaxRate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTaxRate>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteTaxRate>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteTaxRateMutationOptions(options));
};

export const getListMasterSuppliersUrl = (
  params?: ListMasterSuppliersParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/master-suppliers?${stringifiedParams}`
    : `/api/master-suppliers`;
};

export const listMasterSuppliers = async (
  params?: ListMasterSuppliersParams,
  options?: RequestInit,
): Promise<MasterSupplier[]> => {
  return customFetch<MasterSupplier[]>(getListMasterSuppliersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMasterSuppliersQueryKey = (
  params?: ListMasterSuppliersParams,
) => {
  return [`/api/master-suppliers`, ...(params ? [params] : [])] as const;
};

export const getListMasterSuppliersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMasterSuppliers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMasterSuppliersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMasterSuppliers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMasterSuppliersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMasterSuppliers>>
  > = ({ signal }) =>
    listMasterSuppliers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMasterSuppliers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMasterSuppliersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMasterSuppliers>>
>;
export type ListMasterSuppliersQueryError = ErrorType<unknown>;

export function useListMasterSuppliers<
  TData = Awaited<ReturnType<typeof listMasterSuppliers>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMasterSuppliersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMasterSuppliers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMasterSuppliersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateMasterSupplierUrl = () => {
  return `/api/master-suppliers`;
};

export const createMasterSupplier = async (
  createMasterSupplierBody: CreateMasterSupplierBody,
  options?: RequestInit,
): Promise<MasterSupplier> => {
  return customFetch<MasterSupplier>(getCreateMasterSupplierUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMasterSupplierBody),
  });
};

export const getCreateMasterSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMasterSupplier>>,
    TError,
    { data: BodyType<CreateMasterSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMasterSupplier>>,
  TError,
  { data: BodyType<CreateMasterSupplierBody> },
  TContext
> => {
  const mutationKey = ["createMasterSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMasterSupplier>>,
    { data: BodyType<CreateMasterSupplierBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMasterSupplier(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMasterSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMasterSupplier>>
>;
export type CreateMasterSupplierMutationBody =
  BodyType<CreateMasterSupplierBody>;
export type CreateMasterSupplierMutationError = ErrorType<unknown>;

export const useCreateMasterSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMasterSupplier>>,
    TError,
    { data: BodyType<CreateMasterSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMasterSupplier>>,
  TError,
  { data: BodyType<CreateMasterSupplierBody> },
  TContext
> => {
  return useMutation(getCreateMasterSupplierMutationOptions(options));
};

export const getUpdateMasterSupplierUrl = (id: string) => {
  return `/api/master-suppliers/${id}`;
};

export const updateMasterSupplier = async (
  id: string,
  updateMasterSupplierBody: UpdateMasterSupplierBody,
  options?: RequestInit,
): Promise<MasterSupplier> => {
  return customFetch<MasterSupplier>(getUpdateMasterSupplierUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMasterSupplierBody),
  });
};

export const getUpdateMasterSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMasterSupplier>>,
    TError,
    { id: string; data: BodyType<UpdateMasterSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMasterSupplier>>,
  TError,
  { id: string; data: BodyType<UpdateMasterSupplierBody> },
  TContext
> => {
  const mutationKey = ["updateMasterSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMasterSupplier>>,
    { id: string; data: BodyType<UpdateMasterSupplierBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMasterSupplier(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMasterSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMasterSupplier>>
>;
export type UpdateMasterSupplierMutationBody =
  BodyType<UpdateMasterSupplierBody>;
export type UpdateMasterSupplierMutationError = ErrorType<unknown>;

export const useUpdateMasterSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMasterSupplier>>,
    TError,
    { id: string; data: BodyType<UpdateMasterSupplierBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMasterSupplier>>,
  TError,
  { id: string; data: BodyType<UpdateMasterSupplierBody> },
  TContext
> => {
  return useMutation(getUpdateMasterSupplierMutationOptions(options));
};

export const getDeleteMasterSupplierUrl = (id: string) => {
  return `/api/master-suppliers/${id}`;
};

export const deleteMasterSupplier = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMasterSupplierUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMasterSupplierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMasterSupplier>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMasterSupplier>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteMasterSupplier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMasterSupplier>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMasterSupplier(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMasterSupplierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMasterSupplier>>
>;

export type DeleteMasterSupplierMutationError = ErrorType<unknown>;

export const useDeleteMasterSupplier = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMasterSupplier>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMasterSupplier>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteMasterSupplierMutationOptions(options));
};

export const getListMasterStaffUrl = (params?: ListMasterStaffParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/master-staff?${stringifiedParams}`
    : `/api/master-staff`;
};

export const listMasterStaff = async (
  params?: ListMasterStaffParams,
  options?: RequestInit,
): Promise<MasterStaffMember[]> => {
  return customFetch<MasterStaffMember[]>(getListMasterStaffUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMasterStaffQueryKey = (params?: ListMasterStaffParams) => {
  return [`/api/master-staff`, ...(params ? [params] : [])] as const;
};

export const getListMasterStaffQueryOptions = <
  TData = Awaited<ReturnType<typeof listMasterStaff>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMasterStaffParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMasterStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMasterStaffQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMasterStaff>>> = ({
    signal,
  }) => listMasterStaff(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMasterStaff>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMasterStaffQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMasterStaff>>
>;
export type ListMasterStaffQueryError = ErrorType<unknown>;

export function useListMasterStaff<
  TData = Awaited<ReturnType<typeof listMasterStaff>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMasterStaffParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMasterStaff>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMasterStaffQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateMasterStaffMemberUrl = () => {
  return `/api/master-staff`;
};

export const createMasterStaffMember = async (
  createMasterStaffMemberBody: CreateMasterStaffMemberBody,
  options?: RequestInit,
): Promise<MasterStaffMember> => {
  return customFetch<MasterStaffMember>(getCreateMasterStaffMemberUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMasterStaffMemberBody),
  });
};

export const getCreateMasterStaffMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMasterStaffMember>>,
    TError,
    { data: BodyType<CreateMasterStaffMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMasterStaffMember>>,
  TError,
  { data: BodyType<CreateMasterStaffMemberBody> },
  TContext
> => {
  const mutationKey = ["createMasterStaffMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMasterStaffMember>>,
    { data: BodyType<CreateMasterStaffMemberBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createMasterStaffMember(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMasterStaffMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMasterStaffMember>>
>;
export type CreateMasterStaffMemberMutationBody =
  BodyType<CreateMasterStaffMemberBody>;
export type CreateMasterStaffMemberMutationError = ErrorType<unknown>;

export const useCreateMasterStaffMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMasterStaffMember>>,
    TError,
    { data: BodyType<CreateMasterStaffMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMasterStaffMember>>,
  TError,
  { data: BodyType<CreateMasterStaffMemberBody> },
  TContext
> => {
  return useMutation(getCreateMasterStaffMemberMutationOptions(options));
};

export const getUpdateMasterStaffMemberUrl = (id: string) => {
  return `/api/master-staff/${id}`;
};

export const updateMasterStaffMember = async (
  id: string,
  updateMasterStaffMemberBody: UpdateMasterStaffMemberBody,
  options?: RequestInit,
): Promise<MasterStaffMember> => {
  return customFetch<MasterStaffMember>(getUpdateMasterStaffMemberUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMasterStaffMemberBody),
  });
};

export const getUpdateMasterStaffMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMasterStaffMember>>,
    TError,
    { id: string; data: BodyType<UpdateMasterStaffMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMasterStaffMember>>,
  TError,
  { id: string; data: BodyType<UpdateMasterStaffMemberBody> },
  TContext
> => {
  const mutationKey = ["updateMasterStaffMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMasterStaffMember>>,
    { id: string; data: BodyType<UpdateMasterStaffMemberBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMasterStaffMember(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMasterStaffMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMasterStaffMember>>
>;
export type UpdateMasterStaffMemberMutationBody =
  BodyType<UpdateMasterStaffMemberBody>;
export type UpdateMasterStaffMemberMutationError = ErrorType<unknown>;

export const useUpdateMasterStaffMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMasterStaffMember>>,
    TError,
    { id: string; data: BodyType<UpdateMasterStaffMemberBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMasterStaffMember>>,
  TError,
  { id: string; data: BodyType<UpdateMasterStaffMemberBody> },
  TContext
> => {
  return useMutation(getUpdateMasterStaffMemberMutationOptions(options));
};

export const getDeleteMasterStaffMemberUrl = (id: string) => {
  return `/api/master-staff/${id}`;
};

export const deleteMasterStaffMember = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMasterStaffMemberUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMasterStaffMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMasterStaffMember>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMasterStaffMember>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteMasterStaffMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMasterStaffMember>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMasterStaffMember(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMasterStaffMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMasterStaffMember>>
>;

export type DeleteMasterStaffMemberMutationError = ErrorType<unknown>;

export const useDeleteMasterStaffMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMasterStaffMember>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMasterStaffMember>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteMasterStaffMemberMutationOptions(options));
};

/**
 * @summary Request a presigned URL for file upload
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponse> => {
  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<void>;

/**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getGetStorageObjectUrl = (objectPath: string) => {
  return `/api/storage/objects/${objectPath}`;
};

export const getStorageObject = async (
  objectPath: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetStorageObjectUrl(objectPath), {
    ...options,
    method: "GET",
  });
};

export const getGetStorageObjectQueryKey = (objectPath: string) => {
  return [`/api/storage/objects/${objectPath}`] as const;
};

export const getGetStorageObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<void>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageObject>>
  > = ({ signal }) =>
    getStorageObject(objectPath, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!objectPath,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageObject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStorageObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageObject>>
>;
export type GetStorageObjectQueryError = ErrorType<void>;

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<
  TData = Awaited<ReturnType<typeof getStorageObject>>,
  TError = ErrorType<void>,
>(
  objectPath: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStorageObject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStorageObjectQueryOptions(objectPath, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListChartOfAccountsUrl = (
  params?: ListChartOfAccountsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/chart-of-accounts?${stringifiedParams}`
    : `/api/accounting/chart-of-accounts`;
};

export const listChartOfAccounts = async (
  params?: ListChartOfAccountsParams,
  options?: RequestInit,
): Promise<ChartOfAccount[]> => {
  return customFetch<ChartOfAccount[]>(getListChartOfAccountsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListChartOfAccountsQueryKey = (
  params?: ListChartOfAccountsParams,
) => {
  return [
    `/api/accounting/chart-of-accounts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListChartOfAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listChartOfAccounts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListChartOfAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listChartOfAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListChartOfAccountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listChartOfAccounts>>
  > = ({ signal }) =>
    listChartOfAccounts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listChartOfAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListChartOfAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listChartOfAccounts>>
>;
export type ListChartOfAccountsQueryError = ErrorType<unknown>;

export function useListChartOfAccounts<
  TData = Awaited<ReturnType<typeof listChartOfAccounts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListChartOfAccountsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listChartOfAccounts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListChartOfAccountsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateChartOfAccountUrl = () => {
  return `/api/accounting/chart-of-accounts`;
};

export const createChartOfAccount = async (
  createChartOfAccountBody: CreateChartOfAccountBody,
  options?: RequestInit,
): Promise<ChartOfAccount> => {
  return customFetch<ChartOfAccount>(getCreateChartOfAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createChartOfAccountBody),
  });
};

export const getCreateChartOfAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChartOfAccount>>,
    TError,
    { data: BodyType<CreateChartOfAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createChartOfAccount>>,
  TError,
  { data: BodyType<CreateChartOfAccountBody> },
  TContext
> => {
  const mutationKey = ["createChartOfAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createChartOfAccount>>,
    { data: BodyType<CreateChartOfAccountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createChartOfAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateChartOfAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createChartOfAccount>>
>;
export type CreateChartOfAccountMutationBody =
  BodyType<CreateChartOfAccountBody>;
export type CreateChartOfAccountMutationError = ErrorType<unknown>;

export const useCreateChartOfAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createChartOfAccount>>,
    TError,
    { data: BodyType<CreateChartOfAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createChartOfAccount>>,
  TError,
  { data: BodyType<CreateChartOfAccountBody> },
  TContext
> => {
  return useMutation(getCreateChartOfAccountMutationOptions(options));
};

export const getUpdateChartOfAccountUrl = (id: string) => {
  return `/api/accounting/chart-of-accounts/${id}`;
};

export const updateChartOfAccount = async (
  id: string,
  updateChartOfAccountBody: UpdateChartOfAccountBody,
  options?: RequestInit,
): Promise<ChartOfAccount> => {
  return customFetch<ChartOfAccount>(getUpdateChartOfAccountUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateChartOfAccountBody),
  });
};

export const getUpdateChartOfAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChartOfAccount>>,
    TError,
    { id: string; data: BodyType<UpdateChartOfAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateChartOfAccount>>,
  TError,
  { id: string; data: BodyType<UpdateChartOfAccountBody> },
  TContext
> => {
  const mutationKey = ["updateChartOfAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateChartOfAccount>>,
    { id: string; data: BodyType<UpdateChartOfAccountBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateChartOfAccount(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateChartOfAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateChartOfAccount>>
>;
export type UpdateChartOfAccountMutationBody =
  BodyType<UpdateChartOfAccountBody>;
export type UpdateChartOfAccountMutationError = ErrorType<unknown>;

export const useUpdateChartOfAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateChartOfAccount>>,
    TError,
    { id: string; data: BodyType<UpdateChartOfAccountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateChartOfAccount>>,
  TError,
  { id: string; data: BodyType<UpdateChartOfAccountBody> },
  TContext
> => {
  return useMutation(getUpdateChartOfAccountMutationOptions(options));
};

export const getDeleteChartOfAccountUrl = (id: string) => {
  return `/api/accounting/chart-of-accounts/${id}`;
};

export const deleteChartOfAccount = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteChartOfAccountUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteChartOfAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChartOfAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteChartOfAccount>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteChartOfAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteChartOfAccount>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteChartOfAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteChartOfAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteChartOfAccount>>
>;

export type DeleteChartOfAccountMutationError = ErrorType<unknown>;

export const useDeleteChartOfAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteChartOfAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteChartOfAccount>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteChartOfAccountMutationOptions(options));
};

export const getListAccountMappingsUrl = (
  params?: ListAccountMappingsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/account-mappings?${stringifiedParams}`
    : `/api/accounting/account-mappings`;
};

export const listAccountMappings = async (
  params?: ListAccountMappingsParams,
  options?: RequestInit,
): Promise<AccountMapping[]> => {
  return customFetch<AccountMapping[]>(getListAccountMappingsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAccountMappingsQueryKey = (
  params?: ListAccountMappingsParams,
) => {
  return [
    `/api/accounting/account-mappings`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAccountMappingsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountMappings>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAccountMappingsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountMappings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAccountMappingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAccountMappings>>
  > = ({ signal }) =>
    listAccountMappings(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountMappings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAccountMappingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountMappings>>
>;
export type ListAccountMappingsQueryError = ErrorType<unknown>;

export function useListAccountMappings<
  TData = Awaited<ReturnType<typeof listAccountMappings>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAccountMappingsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAccountMappings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAccountMappingsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpsertAccountMappingUrl = () => {
  return `/api/accounting/account-mappings`;
};

export const upsertAccountMapping = async (
  upsertAccountMappingBody: UpsertAccountMappingBody,
  options?: RequestInit,
): Promise<AccountMapping> => {
  return customFetch<AccountMapping>(getUpsertAccountMappingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upsertAccountMappingBody),
  });
};

export const getUpsertAccountMappingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertAccountMapping>>,
    TError,
    { data: BodyType<UpsertAccountMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertAccountMapping>>,
  TError,
  { data: BodyType<UpsertAccountMappingBody> },
  TContext
> => {
  const mutationKey = ["upsertAccountMapping"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertAccountMapping>>,
    { data: BodyType<UpsertAccountMappingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return upsertAccountMapping(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertAccountMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertAccountMapping>>
>;
export type UpsertAccountMappingMutationBody =
  BodyType<UpsertAccountMappingBody>;
export type UpsertAccountMappingMutationError = ErrorType<unknown>;

export const useUpsertAccountMapping = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertAccountMapping>>,
    TError,
    { data: BodyType<UpsertAccountMappingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertAccountMapping>>,
  TError,
  { data: BodyType<UpsertAccountMappingBody> },
  TContext
> => {
  return useMutation(getUpsertAccountMappingMutationOptions(options));
};

export const getApplyDefaultAccountMappingsUrl = (
  params?: ApplyDefaultAccountMappingsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/account-mappings/apply-defaults?${stringifiedParams}`
    : `/api/accounting/account-mappings/apply-defaults`;
};

export const applyDefaultAccountMappings = async (
  applyDefaultAccountMappingsBody?: ApplyDefaultAccountMappingsBody,
  params?: ApplyDefaultAccountMappingsParams,
  options?: RequestInit,
): Promise<ApplyDefaultAccountMappings200> => {
  return customFetch<ApplyDefaultAccountMappings200>(
    getApplyDefaultAccountMappingsUrl(params),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(applyDefaultAccountMappingsBody),
    },
  );
};

export const getApplyDefaultAccountMappingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyDefaultAccountMappings>>,
    TError,
    {
      data: BodyType<ApplyDefaultAccountMappingsBody>;
      params?: ApplyDefaultAccountMappingsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyDefaultAccountMappings>>,
  TError,
  {
    data: BodyType<ApplyDefaultAccountMappingsBody>;
    params?: ApplyDefaultAccountMappingsParams;
  },
  TContext
> => {
  const mutationKey = ["applyDefaultAccountMappings"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyDefaultAccountMappings>>,
    {
      data: BodyType<ApplyDefaultAccountMappingsBody>;
      params?: ApplyDefaultAccountMappingsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return applyDefaultAccountMappings(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyDefaultAccountMappingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyDefaultAccountMappings>>
>;
export type ApplyDefaultAccountMappingsMutationBody =
  BodyType<ApplyDefaultAccountMappingsBody>;
export type ApplyDefaultAccountMappingsMutationError = ErrorType<unknown>;

export const useApplyDefaultAccountMappings = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyDefaultAccountMappings>>,
    TError,
    {
      data: BodyType<ApplyDefaultAccountMappingsBody>;
      params?: ApplyDefaultAccountMappingsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyDefaultAccountMappings>>,
  TError,
  {
    data: BodyType<ApplyDefaultAccountMappingsBody>;
    params?: ApplyDefaultAccountMappingsParams;
  },
  TContext
> => {
  return useMutation(getApplyDefaultAccountMappingsMutationOptions(options));
};

export const getListJournalEntriesUrl = (params?: ListJournalEntriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/journal-entries?${stringifiedParams}`
    : `/api/accounting/journal-entries`;
};

export const listJournalEntries = async (
  params?: ListJournalEntriesParams,
  options?: RequestInit,
): Promise<JournalEntry[]> => {
  return customFetch<JournalEntry[]>(getListJournalEntriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListJournalEntriesQueryKey = (
  params?: ListJournalEntriesParams,
) => {
  return [
    `/api/accounting/journal-entries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListJournalEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listJournalEntries>>,
  TError = ErrorType<unknown>,
>(
  params?: ListJournalEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listJournalEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListJournalEntriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listJournalEntries>>
  > = ({ signal }) => listJournalEntries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listJournalEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListJournalEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listJournalEntries>>
>;
export type ListJournalEntriesQueryError = ErrorType<unknown>;

export function useListJournalEntries<
  TData = Awaited<ReturnType<typeof listJournalEntries>>,
  TError = ErrorType<unknown>,
>(
  params?: ListJournalEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listJournalEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListJournalEntriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateJournalEntryUrl = () => {
  return `/api/accounting/journal-entries`;
};

export const createJournalEntry = async (
  createJournalEntryBody: CreateJournalEntryBody,
  options?: RequestInit,
): Promise<JournalEntry> => {
  return customFetch<JournalEntry>(getCreateJournalEntryUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createJournalEntryBody),
  });
};

export const getCreateJournalEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJournalEntry>>,
    TError,
    { data: BodyType<CreateJournalEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createJournalEntry>>,
  TError,
  { data: BodyType<CreateJournalEntryBody> },
  TContext
> => {
  const mutationKey = ["createJournalEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createJournalEntry>>,
    { data: BodyType<CreateJournalEntryBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createJournalEntry(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateJournalEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof createJournalEntry>>
>;
export type CreateJournalEntryMutationBody = BodyType<CreateJournalEntryBody>;
export type CreateJournalEntryMutationError = ErrorType<unknown>;

export const useCreateJournalEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJournalEntry>>,
    TError,
    { data: BodyType<CreateJournalEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createJournalEntry>>,
  TError,
  { data: BodyType<CreateJournalEntryBody> },
  TContext
> => {
  return useMutation(getCreateJournalEntryMutationOptions(options));
};

export const getUpdateJournalEntryUrl = (id: string) => {
  return `/api/accounting/journal-entries/${id}`;
};

export const updateJournalEntry = async (
  id: string,
  updateJournalEntryBody: UpdateJournalEntryBody,
  options?: RequestInit,
): Promise<JournalEntry> => {
  return customFetch<JournalEntry>(getUpdateJournalEntryUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateJournalEntryBody),
  });
};

export const getUpdateJournalEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJournalEntry>>,
    TError,
    { id: string; data: BodyType<UpdateJournalEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateJournalEntry>>,
  TError,
  { id: string; data: BodyType<UpdateJournalEntryBody> },
  TContext
> => {
  const mutationKey = ["updateJournalEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateJournalEntry>>,
    { id: string; data: BodyType<UpdateJournalEntryBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateJournalEntry(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateJournalEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateJournalEntry>>
>;
export type UpdateJournalEntryMutationBody = BodyType<UpdateJournalEntryBody>;
export type UpdateJournalEntryMutationError = ErrorType<unknown>;

export const useUpdateJournalEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJournalEntry>>,
    TError,
    { id: string; data: BodyType<UpdateJournalEntryBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateJournalEntry>>,
  TError,
  { id: string; data: BodyType<UpdateJournalEntryBody> },
  TContext
> => {
  return useMutation(getUpdateJournalEntryMutationOptions(options));
};

export const getPostJournalEntryUrl = (id: string) => {
  return `/api/accounting/journal-entries/${id}/post`;
};

export const postJournalEntry = async (
  id: string,
  options?: RequestInit,
): Promise<JournalEntry> => {
  return customFetch<JournalEntry>(getPostJournalEntryUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPostJournalEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJournalEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postJournalEntry>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["postJournalEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postJournalEntry>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postJournalEntry(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostJournalEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postJournalEntry>>
>;

export type PostJournalEntryMutationError = ErrorType<unknown>;

export const usePostJournalEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postJournalEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postJournalEntry>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostJournalEntryMutationOptions(options));
};

export const getVoidJournalEntryUrl = (id: string) => {
  return `/api/accounting/journal-entries/${id}/void`;
};

export const voidJournalEntry = async (
  id: string,
  options?: RequestInit,
): Promise<PostJournalEntryResponse> => {
  return customFetch<PostJournalEntryResponse>(getVoidJournalEntryUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getVoidJournalEntryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voidJournalEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof voidJournalEntry>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["voidJournalEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof voidJournalEntry>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return voidJournalEntry(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoidJournalEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof voidJournalEntry>>
>;

export type VoidJournalEntryMutationError = ErrorType<unknown>;

export const useVoidJournalEntry = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voidJournalEntry>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof voidJournalEntry>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getVoidJournalEntryMutationOptions(options));
};

export const getListGlEntriesUrl = (params?: ListGlEntriesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/gl-entries?${stringifiedParams}`
    : `/api/accounting/gl-entries`;
};

export const listGlEntries = async (
  params?: ListGlEntriesParams,
  options?: RequestInit,
): Promise<GlEntry[]> => {
  return customFetch<GlEntry[]>(getListGlEntriesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListGlEntriesQueryKey = (params?: ListGlEntriesParams) => {
  return [`/api/accounting/gl-entries`, ...(params ? [params] : [])] as const;
};

export const getListGlEntriesQueryOptions = <
  TData = Awaited<ReturnType<typeof listGlEntries>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGlEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGlEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGlEntriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listGlEntries>>> = ({
    signal,
  }) => listGlEntries(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGlEntries>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGlEntriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGlEntries>>
>;
export type ListGlEntriesQueryError = ErrorType<unknown>;

export function useListGlEntries<
  TData = Awaited<ReturnType<typeof listGlEntries>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGlEntriesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGlEntries>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGlEntriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetTrialBalanceUrl = (params?: GetTrialBalanceParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/trial-balance?${stringifiedParams}`
    : `/api/accounting/trial-balance`;
};

export const getTrialBalance = async (
  params?: GetTrialBalanceParams,
  options?: RequestInit,
): Promise<TrialBalanceRow[]> => {
  return customFetch<TrialBalanceRow[]>(getGetTrialBalanceUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetTrialBalanceQueryKey = (params?: GetTrialBalanceParams) => {
  return [
    `/api/accounting/trial-balance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTrialBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getTrialBalance>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTrialBalanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrialBalance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTrialBalanceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTrialBalance>>> = ({
    signal,
  }) => getTrialBalance(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTrialBalance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTrialBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTrialBalance>>
>;
export type GetTrialBalanceQueryError = ErrorType<unknown>;

export function useGetTrialBalance<
  TData = Awaited<ReturnType<typeof getTrialBalance>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTrialBalanceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTrialBalance>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTrialBalanceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetBalanceSheetUrl = (params?: GetBalanceSheetParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/balance-sheet?${stringifiedParams}`
    : `/api/accounting/balance-sheet`;
};

export const getBalanceSheet = async (
  params?: GetBalanceSheetParams,
  options?: RequestInit,
): Promise<BalanceSheet> => {
  return customFetch<BalanceSheet>(getGetBalanceSheetUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetBalanceSheetQueryKey = (params?: GetBalanceSheetParams) => {
  return [
    `/api/accounting/balance-sheet`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBalanceSheetQueryOptions = <
  TData = Awaited<ReturnType<typeof getBalanceSheet>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBalanceSheetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBalanceSheet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBalanceSheetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalanceSheet>>> = ({
    signal,
  }) => getBalanceSheet(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBalanceSheet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBalanceSheetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBalanceSheet>>
>;
export type GetBalanceSheetQueryError = ErrorType<unknown>;

export function useGetBalanceSheet<
  TData = Awaited<ReturnType<typeof getBalanceSheet>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBalanceSheetParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBalanceSheet>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBalanceSheetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetIncomeStatementUrl = (params?: GetIncomeStatementParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/income-statement?${stringifiedParams}`
    : `/api/accounting/income-statement`;
};

export const getIncomeStatement = async (
  params?: GetIncomeStatementParams,
  options?: RequestInit,
): Promise<IncomeStatement> => {
  return customFetch<IncomeStatement>(getGetIncomeStatementUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetIncomeStatementQueryKey = (
  params?: GetIncomeStatementParams,
) => {
  return [
    `/api/accounting/income-statement`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIncomeStatementQueryOptions = <
  TData = Awaited<ReturnType<typeof getIncomeStatement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIncomeStatementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIncomeStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIncomeStatementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIncomeStatement>>
  > = ({ signal }) => getIncomeStatement(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIncomeStatement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIncomeStatementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIncomeStatement>>
>;
export type GetIncomeStatementQueryError = ErrorType<unknown>;

export function useGetIncomeStatement<
  TData = Awaited<ReturnType<typeof getIncomeStatement>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIncomeStatementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIncomeStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetIncomeStatementQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetAccountStatementUrl = (
  params: GetAccountStatementParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/account-statement?${stringifiedParams}`
    : `/api/accounting/account-statement`;
};

export const getAccountStatement = async (
  params: GetAccountStatementParams,
  options?: RequestInit,
): Promise<AccountStatement> => {
  return customFetch<AccountStatement>(getGetAccountStatementUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAccountStatementQueryKey = (
  params?: GetAccountStatementParams,
) => {
  return [
    `/api/accounting/account-statement`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAccountStatementQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountStatement>>,
  TError = ErrorType<unknown>,
>(
  params: GetAccountStatementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountStatementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountStatement>>
  > = ({ signal }) =>
    getAccountStatement(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountStatement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountStatementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountStatement>>
>;
export type GetAccountStatementQueryError = ErrorType<unknown>;

export function useGetAccountStatement<
  TData = Awaited<ReturnType<typeof getAccountStatement>>,
  TError = ErrorType<unknown>,
>(
  params: GetAccountStatementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountStatementQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetPartyStatementUrl = (params: GetPartyStatementParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/accounting/party-statement?${stringifiedParams}`
    : `/api/accounting/party-statement`;
};

export const getPartyStatement = async (
  params: GetPartyStatementParams,
  options?: RequestInit,
): Promise<PartyStatement> => {
  return customFetch<PartyStatement>(getGetPartyStatementUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPartyStatementQueryKey = (
  params?: GetPartyStatementParams,
) => {
  return [
    `/api/accounting/party-statement`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPartyStatementQueryOptions = <
  TData = Awaited<ReturnType<typeof getPartyStatement>>,
  TError = ErrorType<unknown>,
>(
  params: GetPartyStatementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartyStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPartyStatementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPartyStatement>>
  > = ({ signal }) => getPartyStatement(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPartyStatement>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPartyStatementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPartyStatement>>
>;
export type GetPartyStatementQueryError = ErrorType<unknown>;

export function useGetPartyStatement<
  TData = Awaited<ReturnType<typeof getPartyStatement>>,
  TError = ErrorType<unknown>,
>(
  params: GetPartyStatementParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPartyStatement>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPartyStatementQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
